(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[358],{

/***/ 65403:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flex/[slug]",
      function () {
        return __webpack_require__(56727);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14470);
/* eslint-disable jsx-a11y/anchor-is-valid */ 


var SingleItemTableSpecs = function(param) {
    var decoratedSpecs = param.decoratedSpecs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: decoratedSpecs.map(function(spec) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: _styles__WEBPACK_IMPORTED_MODULE_2__/* .specsWrapper */ .wp,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: _styles__WEBPACK_IMPORTED_MODULE_2__/* .specCategory */ .XL,
                        children: spec.label
                    }),
                    spec.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: spec.link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: _styles__WEBPACK_IMPORTED_MODULE_2__/* .specValueLink */ .JJ,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/svg/redirect.svg",
                                alt: "external link"
                            }),
                            spec.value
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: _styles__WEBPACK_IMPORTED_MODULE_2__/* .specValueDetail */ .rB,
                        children: spec.value
                    })
                ]
            }, spec.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SingleItemTableSpecs));


/***/ }),

/***/ 14470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ priceContainer; },
/* harmony export */   "JJ": function() { return /* binding */ specValueLink; },
/* harmony export */   "XL": function() { return /* binding */ specCategory; },
/* harmony export */   "XN": function() { return /* binding */ productPrice; },
/* harmony export */   "oF": function() { return /* binding */ isOnSale; },
/* harmony export */   "rB": function() { return /* binding */ specValueDetail; },
/* harmony export */   "wp": function() { return /* binding */ specsWrapper; }
/* harmony export */ });
/* unused harmony exports srOnly, tdSpacing, svgStyles, svgCheckStyles, svgXStyles, dataTableHeadings, dataTableHeadingsFaux, scrollProductSectionImage, productTableHeading, productTableData, productWrapper, productSubheading, price, productButtons, spacingHeader, headingHeader, headingSubtype, tableBody, largeTable, specsSection, singleItemWrapper, singleItemImgWrapper, singleItemProductSubheading, priceStyles, scrollTableWrapper, scrollContainer, scrollIconContainer */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46115);


// sr-only
var srOnly = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("sr-only");
// cell item
var tdSpacing = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("py-5", "pr-4", "lg:py-5", "lg:px-6", "text-nzxt-light-grey-800", "text-center");
var svgStyles = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("h-5", "w-5", "mx-auto");
var svgCheckStyles = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)(svgStyles, "text-nzxt-green-400");
var svgXStyles = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)(svgStyles, "text-nzxt-red-400");
// data section
var scrollDataTableHeadings = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("sticky", "left-0", "bg-nzxt-light-grey-50");
var scrollDataTableHeadingsFaux = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("sticky", "left-0");
var dataTableHeadings = function(isScroll) {
    return classnames("py-5", "px-6", "text-sm", "font-normal", "text-left", "text-nzxt-light-grey-600", _define_property({}, scrollDataTableHeadings, isScroll));
};
var dataTableHeadingsFaux = function(isScroll) {
    return classnames("py-5", "px-6", "text-sm", "font-normal", "text-left", "text-nzxt-light-grey-600", "invisible", _define_property({}, scrollDataTableHeadingsFaux, isScroll));
};
// product section
var scrollProductSectionImage = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("w-48", "md:w-80", "mb-4");
var scrollProductTableHeading = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)(scrollDataTableHeadings, "block", "w-32", "md:w-56", "h-full", "z-10", "flex", "justify-end", "items-end");
var productTableHeading = function(isScroll) {
    return classnames("py-8", "px-6", "text-sm", "font-medium", "text-right", _define_property({}, scrollProductTableHeading, isScroll));
};
var productTableData = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("py-8", "px-6", "h-full", "align-top");
var productWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("relative", "table", "h-full");
var productSubheading = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-sm", "text-nzxt-light-grey-600");
var priceContainer = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("flex", "flex-wrap", "w-full");
var productPrice = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("mb-2");
var price = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("opacity-100");
var priceDiscounted = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("line-through", "text-nzxt-light-grey-600", "text-center", "opacity-75", "mr-2");
var isOnSale = function(salePrice) {
    var _obj;
    return (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, productPrice, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, priceDiscounted, salePrice), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, price, !salePrice), _obj));
};
var productButtons = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-sm", "font-semibold", "text-white", "text-center", "hover:bg-gray-900", "py-2", "rounded-md", "bg-gray-800", "w-full", "block", "flex-grow", "bottom-0", "absolute");
// head section
var scrollspacingHeader = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("sticky", "left-0", "bg-nzxt-light-grey-50");
var spacingHeader = function(isScroll) {
    return classnames("pb-4", "px-6", _define_property({}, scrollspacingHeader, isScroll));
};
var headingHeader = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("mb-2", "mt-2", "text-center", "text-2xl", "md:text-3xl", "font-bold", "leading-relaxed", "text-nzxt-light-grey-800");
var headingSubtype = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("font-thin");
// table
var tableBody = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("divide-y", "divide-gray-200");
var largeTable = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("w-full", "h-px", "table-fixed", "hidden", "lg:table");
// single item
var specsSection = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("grid", "grid-cols-12", "gap-2", "md:gap-2", "text-nzxt-light-grey-800", "border-t", "pt-2");
var specsWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("pt-4", "pb-6", "md:grid", "md:grid-cols-4", "block", "justify-between", "md:col-span-6", "col-span-12", "border-b");
// inner
var specValueDetail = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("col-span-2");
var specValueLink = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-nzxt-blue-400", "hover:underline", "flex", "gap-2", "items-center");
var specCategory = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("font-semibold", "text-nzxt-light-grey-600", "col-span-2");
var singleItemWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("flex", "flex-col", "justify-center", "items-center", "text-center");
var singleItemImgWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("max-w-xs", "mx-auto");
var singleItemProductSubheading = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-sm", "text-nzxt-light-grey-600", "text-center");
var priceStyles = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("my-2", "text-lg", "md:text-2xl", "font-extrabold");
// scroll table
var scrollTableWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("w-full", "h-px", "table", "whitespace-nowrap");
var scrollContainer = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("ml-4", "md:ml-28", "overflow-scroll", "relative");
var scrollIconContainer = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("flex", "items-center", "mr-auto", "text-nzxt-light-grey-800");


/***/ }),

/***/ 74733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ContentWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/ContentWrapper/styles.ts

var contentWrapper = (0,tailwindcss_classnames/* classnames */.d)("w-11/12", "lg:max-w-screen-lg", "xl:max-w-screen-xl", "2xl:max-w-screen-2xl", "mx-auto", "xl:px-20");
/* harmony default export */ var styles = ((/* unused pure expression or super */ null && (contentWrapper)));

;// CONCATENATED MODULE: ./components/ContentWrapper/ContentWrapper.tsx








var ContentWrapper = function(_param) {
    var children = _param.children, className = _param.className, id = _param.id, fullBleed = _param.fullBleed, style = _param.style, dataTestId = _param.dataTestId, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "id",
        "fullBleed",
        "style",
        "dataTestId"
    ]);
    var composedClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)((0,_define_property/* default */.Z)({}, contentWrapper, !fullBleed), className);
    }, [
        className,
        fullBleed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: composedClassName,
        "data-test-id": dataTestId,
        id: id,
        style: style
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var ContentWrapper_ContentWrapper = (/*#__PURE__*/(0,react.memo)(ContentWrapper));

;// CONCATENATED MODULE: ./components/ContentWrapper/index.ts

/* harmony default export */ var components_ContentWrapper = (ContentWrapper_ContentWrapper);


/***/ }),

/***/ 38139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/Divider/styles.ts


var relative = (0,tailwindcss_classnames/* classnames */.d)("relative");
var flexCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var dividerWrapper = (0,tailwindcss_classnames/* classnames */.d)("absolute", "inset-0", flexCenter);
var divider = (0,tailwindcss_classnames/* classnames */.d)("w-full", "border-t", "border-gray-300");
var dividerTextWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative", "flex", "justify-center", "text-sm");
var lightDivider = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-50", "text-gray-500");
var darkDivider = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-800", "text-white");
var dividerText = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("px-2", (_obj = {}, (0,_define_property/* default */.Z)(_obj, darkDivider, isInverted), (0,_define_property/* default */.Z)(_obj, lightDivider, !isInverted), _obj));
};

;// CONCATENATED MODULE: ./components/Divider/Divider.tsx



var Divider = function(param) {
    var text = param.text, isInverted = param.isInverted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: relative,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: dividerWrapper,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: divider
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: dividerTextWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: dividerText(isInverted),
                    children: text
                })
            })
        ]
    });
};
/* harmony default export */ var Divider_Divider = (/*#__PURE__*/(0,react.memo)(Divider));

;// CONCATENATED MODULE: ./components/Divider/index.ts

/* harmony default export */ var components_Divider = (Divider_Divider);


/***/ }),

/***/ 69094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ bestSeller; },
/* harmony export */   "CC": function() { return /* binding */ newItem; },
/* harmony export */   "EJ": function() { return /* binding */ isLimited; },
/* harmony export */   "Hq": function() { return /* binding */ outOfStock; },
/* harmony export */   "I1": function() { return /* binding */ invalid; },
/* harmony export */   "KG": function() { return /* binding */ onSale; },
/* harmony export */   "Q6": function() { return /* binding */ hybridIcon; },
/* harmony export */   "S5": function() { return /* binding */ onClearance; },
/* harmony export */   "aZ": function() { return /* binding */ isPromo; },
/* harmony export */   "mU": function() { return /* binding */ lowStock; },
/* harmony export */   "rv": function() { return /* binding */ hybrid; },
/* harmony export */   "ue": function() { return /* binding */ base; },
/* harmony export */   "w1": function() { return /* binding */ comingSoon; }
/* harmony export */ });
/* harmony import */ var _tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46115);

// eslint-disable-next-line import/prefer-default-export
var base = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("font-semibold", "text-xs", "py-1", "px-2", "inline-flex", "items-center", "rounded-md", "px-2", "py-1", "text-xs", "border");
var outOfStock = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-light-grey-200", "dark:bg-nzxt-dark-grey-500", "text-nzxt-light-grey-700", "dark:text-nzxt-dark-grey-50", "border-transparent");
var lowStock = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-yellow-200", "text-nzxt-brown-500", "border-transparent");
var onSale = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-green-400", "text-white", "border-transparent");
var isPromo = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-green-200", "text-nzxt-green-500", "border-transparent");
var invalid = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-nzxt-red-400", "border-nzxt-red-400");
var newItem = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-blue-400", "text-white", "border-transparent");
var comingSoon = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-blue-300", "text-white", "border-transparent");
var bestSeller = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-nzxt-teal-500", "bg-nzxt-teal-100", "border-transparent");
var onClearance = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-red-400", "text-white", "border-transparent");
var isLimited = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("bg-nzxt-red-400", "text-white", "border-transparent");
var hybrid = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("font-semibold", "text-xs", "py-1", "px-2", "items-center", "rounded-md", "px-2", "py-1", "text-xs", "border", "bg-[#15A5AD]", "block", "my-1", "text-white", "border-transparent");
var hybridIcon = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("w-3", "h-3", "inline", "mr-1");


/***/ }),

/***/ 10058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ImageModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/styles.css
var styles = __webpack_require__(6862);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/dist/reach-dialog.mjs + 49 modules
var reach_dialog = __webpack_require__(35866);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconX.js
var IconX = __webpack_require__(55885);
// EXTERNAL MODULE: ./components/PDP/ColorSelect/ImageModal/Modal.module.css
var Modal_module = __webpack_require__(80326);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/PDP/ColorSelect/ImageModal/styles.ts

var closeButton = (0,tailwindcss_classnames/* classnames */.d)("w-10", "h-10", "p-2", "text-white", "rounded-full", "bg-opacity-60", "bg-nzxt-light-grey-500", "cursor-pointer", "hover:bg-nzxt-light-grey-700", "hover:bg-opacity-60");
var closeButtonWrapper = (0,tailwindcss_classnames/* classnames */.d)("fixed", "opacity-100", "top-10", "right-10", "z-20");

;// CONCATENATED MODULE: ./components/PDP/ColorSelect/ImageModal/ImageModal.tsx








var Modal = function(param) {
    var children = param.children, open = param.open, onClose = param.onClose, ariaLabel = param.ariaLabel, _param_disableClose = param.disableClose, disableClose = _param_disableClose === void 0 ? false : _param_disableClose;
    var CLOSE_MODAL_LABEL = (0,hooks/* useTranslation */.$G)("close_modal_label");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(reach_dialog/* DialogOverlay */.t9, {
        isOpen: open,
        className: (Modal_module_default()).dialogOverlay,
        onDismiss: onClose,
        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(reach_dialog/* DialogContent */.cZ, {
            className: (Modal_module_default()).dialogContent,
            "aria-label": ariaLabel(),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: closeButtonWrapper,
                    children: !disableClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: onClose,
                        "aria-label": CLOSE_MODAL_LABEL,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconX/* default */.Z, {
                            className: closeButton
                        })
                    })
                }),
                children
            ]
        }) : null
    });
};
/* harmony default export */ var ImageModal = (/*#__PURE__*/(0,react.memo)(Modal));

;// CONCATENATED MODULE: ./components/PDP/ColorSelect/ImageModal/index.ts



/***/ }),

/***/ 91464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ modalSliderWrapper; },
/* harmony export */   "Sn": function() { return /* binding */ helperText; },
/* harmony export */   "X2": function() { return /* binding */ colorSelectButton; },
/* harmony export */   "YS": function() { return /* binding */ wrapper; },
/* harmony export */   "aS": function() { return /* binding */ textWrapper; },
/* harmony export */   "ae": function() { return /* binding */ colorItems; },
/* harmony export */   "hH": function() { return /* binding */ productColor; },
/* harmony export */   "kT": function() { return /* binding */ imageItem; },
/* harmony export */   "lv": function() { return /* binding */ img; },
/* harmony export */   "rX": function() { return /* binding */ activeButton; },
/* harmony export */   "sY": function() { return /* binding */ innerColorSelect; }
/* harmony export */ });
/* unused harmony exports container, getActiveItem, mediaWrapper, sharedColorStyle, galleryWrapper, productDisplay */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46115);


var activeItem = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("opacity-100", "visible");
var inactiveItem = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("opacity-0", "hidden");
var container = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("lg:hidden");
var wrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("pb-1", "mb-2");
var textWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("flex", "items-center", "flex-wrap");
var helperText = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-sm", "font-semibold", "mr-2");
var getActiveItem = function(isActive) {
    var _obj;
    return classnames((_obj = {}, _define_property(_obj, activeItem, isActive), _define_property(_obj, inactiveItem, !isActive), _obj), "transition-all", "duration-100");
};
var mediaWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("relative");
var inActiveBackground = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("border", "border-nzxt-light-grey-600", "border-dashed");
var inActiveBackgroundAvail = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("border-nzxt-light-grey-600", "border");
var activeBackground = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("border-2", "border-nzxt-volt-300");
var activeButton = function(isActive, isAvailable) {
    var _obj;
    return (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, inActiveBackground, !isActive && isAvailable), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, inActiveBackgroundAvail, !isActive && !isAvailable), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, activeBackground, isActive), _obj), "flex", "items-center", "justify-center", "mr-2", "mb-2");
};
var colorSelectButton = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("border-2", "border-transparent", "flex", "flex-row", "items-center", "justify-center", "focus:p-4", "relative");
var innerColorSelect = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("absolute");
var sharedColorStyle = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("flex", "justify-start", "flex-wrap", "pt-2");
var colorItems = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)(sharedColorStyle);
var productColor = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-sm", "text-nzxt-light-grey-700", "dark:text-nzxt-dark-grey-200");
var galleryWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("h-full", "lg:col-span-6", "xl:col-span-7", "col-span-1", "row-span-full", "order-1");
var imageItem = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("col-span-1", "flex", "justify-center", "bg-nzxt-light-grey-50", "dark:bg-transparent", "p-4", "xl:p-10", "first:col-span-2", "cursor-pointer");
var modalSliderWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("mb-3");
// mobile
var productDisplay = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("relative", "flex", "px-0", "pb-0", "box-border", "col-span-1", "order-1");
var img = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("w-full", "h-auto", "max-h-full", "object-cover");


/***/ }),

/***/ 60451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SectionWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44514);
/* harmony import */ var _components_ContentWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74733);
/* harmony import */ var _components_VideoBlock_VideoBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11839);
/* harmony import */ var _components_ContentGrid_ContentGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97589);
/* harmony import */ var _components_VideoCarousel_VideoCarousel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65953);









var OverviewContentSection = function(param) {
    var _param_overviewContent = param.overviewContent, overviewContent = _param_overviewContent === void 0 ? [] : _param_overviewContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: overviewContent.map(function(contentBlock) {
            // eslint-disable-next-line no-underscore-dangle
            switch(contentBlock._modelApiKey){
                case "tabs_grid":
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContentGrid_ContentGrid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, contentBlock), {
                        noWrapperSpacing: true
                    }), contentBlock.id);
                case "video_block":
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        noSpacing: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContentWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoBlock_VideoBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                heading: contentBlock.heading,
                                eyebrow: contentBlock.eyebrow,
                                subheading: contentBlock.subheading,
                                video: contentBlock.video,
                                videoPoster: contentBlock.videoPoster,
                                buttonLabel: contentBlock.buttonLabel,
                                buttonLink: contentBlock.internalButtonLink,
                                darkText: contentBlock.darkText,
                                noWrapperSpacing: true,
                                rounded: true
                            })
                        })
                    }, contentBlock.id);
                case "video_carousel":
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoCarousel_VideoCarousel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, contentBlock), {
                        isCompact: true
                    }), contentBlock.id);
                default:
                    return null;
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(OverviewContentSection));


/***/ }),

/***/ 17300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ ProductNav_OuterWrapper; },
  "z": function() { return /* reexport */ ProductNav_ProductNav; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ContentWrapper/index.ts + 2 modules
var ContentWrapper = __webpack_require__(74733);
// EXTERNAL MODULE: ./components/Imgix/index.ts + 6 modules
var Imgix = __webpack_require__(56090);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconChevronRight.js
var IconChevronRight = __webpack_require__(44572);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/PDP/ProductNav/styles.ts


// bread crumbs
var breadCrumbPageLabel = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-800", "ml-1");
var breadCrumbWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center", "justify-between");
var breadCrumb = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "text-nzxt-light-grey-600", "flex", "items-center", "font-semibold");
var breadCrumbItem = (0,tailwindcss_classnames/* classnames */.d)("font-bold", "hover:underline", "mr-1");
// outerWrapper
var outerWrapper = (0,tailwindcss_classnames/* classnames */.d)("bg-white", "opacity-100", "py-2", "lg:fixed", "border-b", "w-screen", "lg:z-20", "overflow-hidden");
var innerWrapper = (0,tailwindcss_classnames/* classnames */.d)("bg-white", "w-full", "flex", "justify-between", "max-w-screen-2xl", "relative", "m-auto", "w-full", "md:py-2.5", "py-2", "overflow-hidden");
var productName = (0,tailwindcss_classnames/* classnames */.d)("font-semibold");
var activeAction = (0,tailwindcss_classnames/* classnames */.d)("rotate-180");
var chevron = function(isActive) {
    return classnames("h-5", "w-5", _define_property({}, activeAction, isActive), "stroke-current", "ml-1", "transition-transform", "duration-200", "transform", "group-nested-link-hover:text-nzxt-volt-400");
};
var linksWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var anchorLinks = (0,tailwindcss_classnames/* classnames */.d)("mx-auto", "capitalize", "py-2", "focus:outline-none");
var extendedButtonStyles = (0,tailwindcss_classnames/* classnames */.d)("mr-0", "ml-4");
var sectionDrowpdownButton = (0,tailwindcss_classnames/* classnames */.d)("inline-flex", "justify-center", "items-center", "w-full", "px-4", "md:px-10", "px-4", "py-1", "bg-white", "font-semibold", "text-nzxt-dark-grey-600", "h-10");
var dropdownContainer = (0,tailwindcss_classnames/* classnames */.d)("origin-top-right", "absolute", "right-0", "mt-3", "w-56", "rounded-md", "overflow-hidden", "border-none", "shadow-lg", "bg-white", "min-w-full");
var anchorLinkWrapperSmall = (0,tailwindcss_classnames/* classnames */.d)("origin-top-right", "absolute", "-right-40", "top-27", "overflow-hidden", "border-none", "shadow-lg", "bg-white", "ring-1", "ring-black", "ring-opacity-5", "min-w-full", "w-screen");
var buttonWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "py-1");
var styles_button = (0,tailwindcss_classnames/* classnames */.d)("mr-0", "ml-4");

;// CONCATENATED MODULE: ./components/PDP/ProductNav/ProductNav.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var ProductNav = function(param) {
    var collectionData = param.collectionData, productName = param.productName, productCategory = param.productCategory;
    var SERIES = (0,hooks/* useTranslation */.$G)("series_label");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: innerWrapper,
        style: {
            maxWidth: "100vw"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: breadCrumbWrapper,
                children: collectionData && collectionData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: breadCrumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/collection/".concat(collectionData[0].slug),
                                    passHref: true,
                                    className: breadCrumbItem,
                                    children: collectionData[0].name.includes("Series") ? collectionData[0].name : "".concat(collectionData[0].name, " ").concat(SERIES)
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronRight/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: breadCrumbPageLabel,
                                    children: productName
                                })
                            ]
                        }),
                        productCategory === "prebuilds" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden md:inline-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Imgix/* ResponsiveImage */.t, {
                                imageUrl: "https://www.datocms-assets.com/34299/1714395008-windows-11_banner_650x95_blue-1.png",
                                imgixParams: {
                                    w: 256,
                                    h: 38,
                                    auto: "format"
                                },
                                height: 38,
                                width: 256,
                                urlType: "srcset",
                                alt: "Windows 11",
                                className: "w-64"
                            })
                        })
                    ]
                }) : null
            })
        })
    });
};
/* harmony default export */ var ProductNav_ProductNav = (/*#__PURE__*/(0,react.memo)(ProductNav));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/PDP/ProductNav/OuterWrapper.tsx






var OuterWrapper = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: outerWrapper
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var ProductNav_OuterWrapper = (/*#__PURE__*/(0,react.memo)(OuterWrapper));

;// CONCATENATED MODULE: ./components/PDP/ProductNav/index.ts





/***/ }),

/***/ 21214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PDP_PurchaseOptionsNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/index.ts + 18 modules
var constants = __webpack_require__(28448);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/PDP/PurchaseOptionsNav/styles.ts
// styles.ts


var baseNavItem = (0,tailwindcss_classnames/* classnames */.d)("px-2", "py-2", "rounded-md", "col-span-1");
var navItem = (0,tailwindcss_classnames/* classnames */.d)(baseNavItem, "font-normal", "bg-nzxt-light-grey-100", "dark:bg-nzxt-dark-grey-200", "first:rounded-r-none", "first:rounded-l-md", "rounded-l-none");
var activeNavItem = (0,tailwindcss_classnames/* classnames */.d)("bg-white", "dark:bg-nzxt-dark-grey-700", "shadow-activeBorderDefault", "dark:shadow-activeBorderInverse", "border-transparent", "font-semibold", "z-10");
var isActiveNavItem = function(isActive) {
    return (0,tailwindcss_classnames/* classnames */.d)(baseNavItem, (0,_define_property/* default */.Z)({}, activeNavItem, isActive));
};
var navItemLabel = (0,tailwindcss_classnames/* classnames */.d)("block");
var navItemSublabel = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-600", "dark:text-nzxt-dark-grey-200", "text-xs", "font-normal", "block");
var navWrapper = (0,tailwindcss_classnames/* classnames */.d)("w-full", "mb-6");
var nav = (0,tailwindcss_classnames/* classnames */.d)("grid", "grid-cols-2", "text-center", "bg-nzxt-light-grey-100", "dark:bg-nzxt-dark-grey-500", "rounded-t-md", "relative", "z-10");
var servicesWrapper = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-50", "dark:bg-nzxt-dark-grey-600", "pt-8", "px-6", "pb-6", "rounded-b-md", "-mt-2", "space-y-2");

;// CONCATENATED MODULE: ./components/PDP/PurchaseOptionsNav/NavItem.tsx
// NavItem.tsx



var NavItem = function(param) {
    var label = param.label, sublabel = param.sublabel, path = param.path, isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: isActiveNavItem(isActive),
        children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: navItemSublabel,
                    children: sublabel
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            className: "block",
            href: path,
            children: [
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: navItemSublabel,
                    children: sublabel
                })
            ]
        })
    }, label);
};
/* harmony default export */ var PurchaseOptionsNav_NavItem = (NavItem);

// EXTERNAL MODULE: ./components/PDP/ServiceBadge/index.ts + 3 modules
var ServiceBadge = __webpack_require__(17876);
;// CONCATENATED MODULE: ./components/PDP/PurchaseOptionsNav/PurchaseOptionsNav.tsx









var PurchaseOptionsNav = function(param) {
    var slug = param.slug, siblingSlug = param.siblingSlug, regionalServices = param.regionalServices;
    var router = (0,next_router.useRouter)();
    var _router_asPath_split = (0,_sliced_to_array/* default */.Z)(router.asPath.split("?"), 1), pathWithoutQuery = _router_asPath_split[0];
    var isActivePath = function(path) {
        return pathWithoutQuery === path;
    };
    if (!siblingSlug) {
        return null;
    }
    var BUY_LABEL = (0,hooks/* useTranslation */.$G)("buy_nav_label");
    var BUY_SUBLABEL = (0,hooks/* useTranslation */.$G)("buy_nav_sublabel");
    var LEASE_LABEL = (0,hooks/* useTranslation */.$G)("lease_nav_label");
    var LEASE_SUBLABEL = (0,hooks/* useTranslation */.$G)("lease_nav_sublabel");
    var getPath = function(route) {
        return isActivePath("/".concat(route, "/").concat(slug)) ? "/".concat(route, "/").concat(slug) : "/".concat(route, "/").concat(siblingSlug);
    };
    var navigationItems = [
        {
            label: BUY_LABEL,
            sublabel: BUY_SUBLABEL,
            path: getPath(constants/* ROUTE_PRODUCT */.e_n)
        },
        {
            label: LEASE_LABEL,
            sublabel: LEASE_SUBLABEL,
            path: getPath(constants/* ROUTE_SUBSCRIPTION */.xzr)
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: navWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: nav,
                children: navigationItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseOptionsNav_NavItem, {
                        label: item.label,
                        sublabel: item.sublabel,
                        path: item.path,
                        isActive: isActivePath(item.path)
                    }, item.label);
                })
            }),
            regionalServices && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: servicesWrapper,
                children: [
                    (regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.bundlesPromos) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceBadge/* default */.Z, {
                        data: regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.bundlesPromos
                    }),
                    (regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.shippingNotices) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceBadge/* default */.Z, {
                        data: regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.shippingNotices
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PurchaseOptionsNav_PurchaseOptionsNav = (/*#__PURE__*/(0,react.memo)(PurchaseOptionsNav));

;// CONCATENATED MODULE: ./components/PDP/PurchaseOptionsNav/index.ts

/* harmony default export */ var PDP_PurchaseOptionsNav = (PurchaseOptionsNav_PurchaseOptionsNav);


/***/ }),

/***/ 17876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PDP_ServiceBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/gtm/index.ts + 3 modules
var gtm = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./utils/get-cms-link-url.ts
var get_cms_link_url = __webpack_require__(91087);
// EXTERNAL MODULE: ./components/IconDynamic/index.ts + 1 modules
var IconDynamic = __webpack_require__(97390);
// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(87029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/PDP/ServiceBadge/styles.ts


var itemsCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var defaultStyles = (0,tailwindcss_classnames/* classnames */.d)("justify-start");
var chipStyles = (0,tailwindcss_classnames/* classnames */.d)("justify-center", "px-2", "py-1", "border", "rounded-md", "max-w-max", "whitespace-nowrap", "mr-2", "mb-2");
var lgSpace = (0,tailwindcss_classnames/* classnames */.d)("pb-3");
var detailsBox = function(asChip, isLg) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)(itemsCenter, (_obj = {}, (0,_define_property/* default */.Z)(_obj, defaultStyles, !asChip), (0,_define_property/* default */.Z)(_obj, chipStyles, asChip), (0,_define_property/* default */.Z)(_obj, lgSpace, isLg), _obj));
};
var shippingSection = (0,tailwindcss_classnames/* classnames */.d)(itemsCenter);
var iconSize = (0,tailwindcss_classnames/* classnames */.d)("w-5", "h-5", "text-nzxt-dark-grey-500", "dark:text-white", "fill-current", "mr-3");
var defaultText = (0,tailwindcss_classnames/* classnames */.d)("text-xs");
var lgText = (0,tailwindcss_classnames/* classnames */.d)("text-sm");
var styles_text = function(isLg) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-500", "dark:text-white", "flex", "items-center", (_obj = {}, (0,_define_property/* default */.Z)(_obj, defaultText, !isLg), (0,_define_property/* default */.Z)(_obj, lgText, isLg), _obj));
};
var buttonOverrides = (0,tailwindcss_classnames/* classnames */.d)("ml-1", "text-blue-600", "text-nzxt-volt-400", "hover:underline");
var styles_button = (0,tailwindcss_classnames/* classnames */.d)("!font-thin");
var modalContent = (0,tailwindcss_classnames/* classnames */.d)("py-4");
var heading = (0,tailwindcss_classnames/* classnames */.d)("h6", "pb-4", "font-bold");

// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(86496);
;// CONCATENATED MODULE: ./components/PDP/ServiceBadge/ServiceButton.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable no-nested-ternary */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-underscore-dangle */ 



var ServiceButton = function(param) {
    var _param_isModal = param.isModal, isModal = _param_isModal === void 0 ? false : _param_isModal, _param_newTab = param.newTab, newTab = _param_newTab === void 0 ? false : _param_newTab, internalLink = param.internalLink, externalLink = param.externalLink, heading = param.heading, markdownContent = param.markdownContent, buttonLabel = param.buttonLabel, handleModal = param.handleModal, handleEvent = param.handleEvent;
    return buttonLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
            className: styles_button,
            noChevron: true,
            onClick: function() {
                return handleModal(markdownContent, heading);
            },
            children: buttonLabel
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: internalLink || externalLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                className: styles_button,
                internalLink: Boolean(internalLink),
                href: internalLink || externalLink,
                target: Boolean(externalLink) || newTab ? "_blank" : undefined,
                rel: Boolean(externalLink) || newTab ? "noopener noreferrer" : undefined,
                noChevron: true,
                onClick: function() {
                    return handleEvent();
                },
                children: buttonLabel
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: buttonLabel
            })
        })
    }) : null;
};
/* harmony default export */ var ServiceBadge_ServiceButton = (/*#__PURE__*/(0,react.memo)(ServiceButton));

;// CONCATENATED MODULE: ./components/PDP/ServiceBadge/ServiceBadge.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable no-nested-ternary */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-underscore-dangle */ 








// NOTE: The external link is limited to the 'Service' field in the 'Service Item' model which is a multireference link field
var ServiceBadge = function(param) {
    var data = param.data, _param_lg = param.lg, lg = _param_lg === void 0 ? false : _param_lg, _param_asChip = param.asChip, asChip = _param_asChip === void 0 ? false : _param_asChip, eventType = param.eventType;
    var _link_parentCategory, _data_externalLink, _data_internalLink, _data_internalLink_, _data_internalLink1;
    var setModalView = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetModalView */.Bz);
    var setModalContent = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetModalContent */.zt);
    var openModal = (0,use_ui_store/* default */.ZP)(use_ui_store/* getOpenModal */.Qe);
    var closeModal = (0,use_ui_store/* default */.ZP)(use_ui_store/* getCloseModal */.MK);
    var handleNoticeModal = function(markdownContent, header) {
        setModalView("NOTICE_PAGE");
        setModalContent({
            markdownCopy: header,
            markdownContent: markdownContent
        });
        openModal();
    };
    var link = Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) > 0 ? null : !Array.isArray(data) && Array.isArray(data === null || data === void 0 ? void 0 : data.internalLink) ? !Array.isArray(data) && data.internalLink[0] : !Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.internalLink);
    var internalHref = link ? (0,get_cms_link_url/* default */.Z)({
        contentType: link._modelApiKey,
        pageType: link.pageType,
        slug: link.slug,
        parentSlug: (_link_parentCategory = link.parentCategory) === null || _link_parentCategory === void 0 ? void 0 : _link_parentCategory.slug
    }) : null;
    var handleLinkClick = function(event) {
        gtm/* default.dataLayer */.Z.dataLayer({
            dataLayer: {
                event: event
            }
        });
    };
    (0,react.useEffect)(function() {
        router_default().events.on("routeChangeComplete", function() {
            return closeModal();
        });
        return function() {
            router_default().events.off("routeChangeComplete", function() {
                return closeModal();
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data === null || data === void 0 ? void 0 : data.map(function(service) {
            var _serviceLink_parentCategory, _service_internalLink, _service_internalLink_, _service_internalLink1, _service_externalLink;
            var serviceLink = Array.isArray(service === null || service === void 0 ? void 0 : service.internalLink) ? service.internalLink[0] : service === null || service === void 0 ? void 0 : service.internalLink;
            var internalServiceHref = serviceLink ? (0,get_cms_link_url/* default */.Z)({
                contentType: serviceLink._modelApiKey,
                pageType: serviceLink.pageType,
                slug: serviceLink.slug,
                parentSlug: (_serviceLink_parentCategory = serviceLink.parentCategory) === null || _serviceLink_parentCategory === void 0 ? void 0 : _serviceLink_parentCategory.slug
            }) : null;
            var modalContent = (service === null || service === void 0 ? void 0 : service.noticeMarkdownContent) || (service === null || service === void 0 ? void 0 : service.decoratedMarkdownContent);
            var modalHeading = Array.isArray(service === null || service === void 0 ? void 0 : service.internalLink) ? (service === null || service === void 0 ? void 0 : (_service_internalLink = service.internalLink) === null || _service_internalLink === void 0 ? void 0 : (_service_internalLink_ = _service_internalLink[0]) === null || _service_internalLink_ === void 0 ? void 0 : _service_internalLink_.heading) || (service === null || service === void 0 ? void 0 : service.copy) : (service === null || service === void 0 ? void 0 : (_service_internalLink1 = service.internalLink) === null || _service_internalLink1 === void 0 ? void 0 : _service_internalLink1.heading) || (service === null || service === void 0 ? void 0 : service.copy);
            return (service === null || service === void 0 ? void 0 : service.copy) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: detailsBox(asChip, lg),
                    "data-test-id": "service-badge",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: styles_text(lg),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDynamic/* default */.Z, {
                                iconName: service.iconName,
                                className: iconSize
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceBadge_ServiceButton, {
                                isModal: Boolean(modalContent),
                                newTab: service === null || service === void 0 ? void 0 : service.newTab,
                                internalLink: internalServiceHref,
                                externalLink: service === null || service === void 0 ? void 0 : (_service_externalLink = service.externalLink) === null || _service_externalLink === void 0 ? void 0 : _service_externalLink.url,
                                heading: modalHeading,
                                markdownContent: modalContent,
                                buttonLabel: service === null || service === void 0 ? void 0 : service.copy,
                                handleModal: handleNoticeModal,
                                handleEvent: function() {
                                    return handleLinkClick(eventType);
                                }
                            })
                        ]
                    })
                })
            }, service === null || service === void 0 ? void 0 : service.id) : null;
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.copy) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: detailsBox(asChip, lg),
            "data-test-id": "not-notice-mk-service-badge",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styles_text(lg),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDynamic/* default */.Z, {
                        iconName: data.iconName,
                        className: iconSize
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceBadge_ServiceButton, {
                        isModal: Boolean((data === null || data === void 0 ? void 0 : data.noticeMarkdownContent) || (data === null || data === void 0 ? void 0 : data.decoratedMarkdownContent)),
                        newTab: data === null || data === void 0 ? void 0 : data.newTab,
                        internalLink: internalHref,
                        externalLink: data === null || data === void 0 ? void 0 : (_data_externalLink = data.externalLink) === null || _data_externalLink === void 0 ? void 0 : _data_externalLink.url,
                        heading: Array.isArray(data === null || data === void 0 ? void 0 : data.internalLink) ? (data === null || data === void 0 ? void 0 : (_data_internalLink = data.internalLink) === null || _data_internalLink === void 0 ? void 0 : (_data_internalLink_ = _data_internalLink[0]) === null || _data_internalLink_ === void 0 ? void 0 : _data_internalLink_.heading) || (data === null || data === void 0 ? void 0 : data.copy) : (data === null || data === void 0 ? void 0 : (_data_internalLink1 = data.internalLink) === null || _data_internalLink1 === void 0 ? void 0 : _data_internalLink1.heading) || (data === null || data === void 0 ? void 0 : data.copy),
                        markdownContent: (data === null || data === void 0 ? void 0 : data.noticeMarkdownContent) || (data === null || data === void 0 ? void 0 : data.decoratedMarkdownContent),
                        buttonLabel: data === null || data === void 0 ? void 0 : data.copy,
                        handleModal: handleNoticeModal,
                        handleEvent: function() {
                            return handleLinkClick(eventType);
                        }
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ var ServiceBadge_ServiceBadge = (/*#__PURE__*/(0,react.memo)(ServiceBadge));

;// CONCATENATED MODULE: ./components/PDP/ServiceBadge/index.ts

/* harmony default export */ var PDP_ServiceBadge = (ServiceBadge_ServiceBadge);


/***/ }),

/***/ 45129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ column; },
/* harmony export */   "Dd": function() { return /* binding */ smallSpaceDivider; },
/* harmony export */   "EQ": function() { return /* binding */ titleBase; },
/* harmony export */   "HW": function() { return /* binding */ regularMargin; },
/* harmony export */   "QS": function() { return /* binding */ discountedPricedText; },
/* harmony export */   "SC": function() { return /* binding */ servicesWrapper; },
/* harmony export */   "VT": function() { return /* binding */ fullSpanWrapper; },
/* harmony export */   "dE": function() { return /* binding */ greyText; },
/* harmony export */   "f2": function() { return /* binding */ mainDetail; },
/* harmony export */   "g8": function() { return /* binding */ titlePrice; },
/* harmony export */   "oF": function() { return /* binding */ isOnSale; },
/* harmony export */   "rk": function() { return /* binding */ policiesWrapper; },
/* harmony export */   "tO": function() { return /* binding */ detailsGrid; }
/* harmony export */ });
/* unused harmony export reviewsContainer */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46115);


// outer containers
var detailsGrid = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("grid", "grid-cols-1", "lg:grid-cols-12", "lg:gap-10", "gap-0", "pt-3", "md:pt-3", "lg:pt-20");
var column = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("col-span-1", "lg:col-span-5", "xl:col-span-5", "md:flex-shrink-0", "mt-3", "md:mt-0", "order-2");
var reviewsContainer = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("mt-3", "min-h-[17.5px]");
var fullSpanWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("col-span-full");
var regularMargin = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("mb-6");
// product information (name, description, price, affirm)
var mainDetail = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("grid", "gap-x-4", "gap-y-1", "md:gap-y-2", "grid-cols-6", "mt-3", "mb-3", "md:mb-4");
var titleBase = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("h4");
var greyText = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-nzxt-light-grey-800", "dark:text-nzxt-dark-grey-200");
var titlePrice = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("font-semibold", "text-nzxt-light-grey-800", "dark:text-white", "space-x-2", "text-right", "my-auto", "flex", "col-span-full", "text-2xl");
var priceDiscounted = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("line-through", "text-nzxt-light-grey-600", "dark:text-nzxt-dark-grey-200");
var discountedPricedText = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("text-nzxt-light-grey-800", "dark:text-white");
var isOnSale = function(salePrice) {
    return (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, priceDiscounted, salePrice));
};
// services and policies
var servicesWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("col-span-6", "flex", "flex-wrap", "mb-2");
var policiesWrapper = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("space-y-2", "mb-3", "mt-3", "pt-6", "border-t", "dark:border-t-nzxt-dark-grey-100");
var smallSpaceDivider = (0,_tailwindcss_classnames__WEBPACK_IMPORTED_MODULE_0__/* .classnames */ .d)("pt-3");


/***/ }),

/***/ 82677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionHeading_SectionHeading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/SectionHeading/styles.ts


var centerPos = (0,tailwindcss_classnames/* classnames */.d)("text-center", "mx-auto");
var wrapper = function(textPos) {
    return (0,tailwindcss_classnames/* classnames */.d)("space-y-2", "mb-6", "md:mb-8", "lg:mb-10", "w-11/12", "md:max-w-screen-sm", "lg:max-w-screen-lg", "xl:max-w-screen-xl", (0,_define_property/* default */.Z)({}, centerPos, textPos === "center"));
};
var styles_heading = function(textPos, headingSize) {
    return (0,tailwindcss_classnames/* classnames */.d)((0,_define_property/* default */.Z)({
        h3: headingSize === "large",
        h5: headingSize === "small",
        "hyphen-auto": true
    }, centerPos, textPos === "center"));
};
var darkColor = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-700");
var defaultColor = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-600");
var styles_subheading = function(textPos, darkenSubheading) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("max-w-ch-50", (_obj = {}, (0,_define_property/* default */.Z)(_obj, centerPos, textPos === "center"), (0,_define_property/* default */.Z)(_obj, darkColor, darkenSubheading), (0,_define_property/* default */.Z)(_obj, defaultColor, !darkenSubheading), _obj));
};
var styles_image = function(textPos) {
    return (0,tailwindcss_classnames/* classnames */.d)("h-5", "md:h-6", "w-auto", "block", "mb-3", "md:mb-4", (0,_define_property/* default */.Z)({}, centerPos, textPos === "center"));
};

;// CONCATENATED MODULE: ./components/SectionHeading/eyebrow.tsx



var Eyebrow = function(param) {
    var image = param.image, textPosition = param.textPosition;
    var nonResponsiveUrl = image.nonResponsiveUrl, alt = image.alt, height = image.height, width = image.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: styles_image(textPosition),
        src: image && nonResponsiveUrl,
        alt: image && alt,
        height: image && height,
        width: image && width,
        loading: "lazy",
        decoding: "async",
        "data-test-id": "section-eyebrow"
    });
};
/* harmony default export */ var SectionHeading_eyebrow = (/*#__PURE__*/(0,react.memo)(Eyebrow));

;// CONCATENATED MODULE: ./components/SectionHeading/SectionHeading.tsx




var SectionHeading = function(param) {
    var heading = param.heading, subheading = param.subheading, eyebrowLogo = param.eyebrowLogo, eyebrow = param.eyebrow, lang = param.lang, textPosition = param.textPosition, _param_darkenSubheading = param.darkenSubheading, darkenSubheading = _param_darkenSubheading === void 0 ? false : _param_darkenSubheading, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? "large" : _param_headingSize;
    var sanitizedTextPosition = (textPosition === null || textPosition === void 0 ? void 0 : textPosition.toLowerCase()) || "center";
    return heading || subheading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapper(sanitizedTextPosition),
        "data-test-id": "section-heading-block",
        children: [
            eyebrowLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeading_eyebrow, {
                textPosition: sanitizedTextPosition,
                image: eyebrowLogo
            }),
            eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: eyebrow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                lang: lang,
                className: styles_heading(sanitizedTextPosition, headingSize),
                "data-test-id": "section-heading",
                children: heading
            }),
            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: styles_subheading(sanitizedTextPosition, darkenSubheading),
                "data-test-id": "section-subheading",
                children: subheading
            })
        ]
    }) : null;
};
/* harmony default export */ var SectionHeading_SectionHeading = (/*#__PURE__*/(0,react.memo)(SectionHeading));

;// CONCATENATED MODULE: ./components/SectionHeading/index.ts



/***/ }),

/***/ 44514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SectionWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./components/SectionWrapper/styles.ts

var sectionWrapper = (0,tailwindcss_classnames/* classnames */.d)("py-6", "md:py-12", "xl:py-16");
// Top Spacing
var defaultTop = (0,tailwindcss_classnames/* classnames */.d)("pt-6", "md:pt-12", "xl:pt-16");
var smallTop = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "md:pt-6", "xl:pt-8");
var noneTop = (0,tailwindcss_classnames/* classnames */.d)("pt-0", "md:pt-0", "xl:pt-0");
// Bottom Spacing
var defaultBottom = (0,tailwindcss_classnames/* classnames */.d)("pb-6", "md:pb-12", "xl:pb-16");
var smallBottom = (0,tailwindcss_classnames/* classnames */.d)("pb-4", "md:pb-6", "xl:pb-8");
var noneBottom = (0,tailwindcss_classnames/* classnames */.d)("pb-0", "md:pb-0", "xl:pb-0");
/* harmony default export */ var styles = ((/* unused pure expression or super */ null && (sectionWrapper)));

;// CONCATENATED MODULE: ./components/SectionWrapper/SectionWrapper.tsx
/* eslint-disable no-nested-ternary */ 






// TODO: variableSpacing is a stop gap to a real spacing solution
// based on how this is used by content
// discussion is required @dan @donny
var SectionWrapper = function(_param) {
    var children = _param.children, className = _param.className, id = _param.id, ref = _param.ref, style = _param.style, _param_noSpacing = _param.noSpacing, noSpacing = _param_noSpacing === void 0 ? false : _param_noSpacing, variableSpacing = _param.variableSpacing, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "id",
        "ref",
        "style",
        "noSpacing",
        "variableSpacing"
    ]);
    var variableSpacingStrings = variableSpacing ? variableSpacing === null || variableSpacing === void 0 ? void 0 : variableSpacing.split("/") : [];
    var spacingValuesTop = {
        Default: defaultTop,
        Small: smallTop,
        None: noneTop
    };
    var spacingValuesBottom = {
        Default: defaultBottom,
        Small: smallBottom,
        None: noneBottom
    };
    var composedClassName = (0,react.useMemo)(function() {
        return !noSpacing ? (variableSpacingStrings === null || variableSpacingStrings === void 0 ? void 0 : variableSpacingStrings.length) === 2 ? (0,clsx_m/* default */.Z)(spacingValuesTop[variableSpacingStrings[0]], spacingValuesBottom[variableSpacingStrings[1]], className) : (0,clsx_m/* default */.Z)(sectionWrapper, className) : className ? (0,clsx_m/* default */.Z)(className) : null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        className,
        noSpacing,
        variableSpacingStrings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: composedClassName,
        id: id
    }, rest), {
        style: style,
        children: children
    }));
};
/* harmony default export */ var SectionWrapper_SectionWrapper = (/*#__PURE__*/(0,react.memo)(SectionWrapper));

;// CONCATENATED MODULE: ./components/SectionWrapper/index.ts

/* harmony default export */ var components_SectionWrapper = (SectionWrapper_SectionWrapper);


/***/ }),

/***/ 56727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
var error_default = /*#__PURE__*/__webpack_require__.n(error);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 17 modules
var hooks = __webpack_require__(8904);
// EXTERNAL MODULE: ./constants/index.ts + 18 modules
var constants = __webpack_require__(28448);
// EXTERNAL MODULE: ./components/Head/index.ts + 1 modules
var Head = __webpack_require__(68368);
// EXTERNAL MODULE: ./components/Layout/index.ts + 25 modules
var Layout = __webpack_require__(16119);
// EXTERNAL MODULE: ./components/ContentWrapper/index.ts + 2 modules
var ContentWrapper = __webpack_require__(74733);
// EXTERNAL MODULE: ./components/SectionWrapper/index.ts + 2 modules
var SectionWrapper = __webpack_require__(44514);
// EXTERNAL MODULE: ./components/PDP/ProductNav/index.ts + 3 modules
var ProductNav = __webpack_require__(17300);
// EXTERNAL MODULE: ./components/PDP/Downloads/index.ts + 8 modules
var Downloads = __webpack_require__(8773);
// EXTERNAL MODULE: ./components/FAQSection/index.ts + 2 modules
var FAQSection = __webpack_require__(75547);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-scroll/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(2837);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/PDP/PurchaseOptionsNav/index.ts + 3 modules
var PurchaseOptionsNav = __webpack_require__(21214);
// EXTERNAL MODULE: ./components/PDP/styles.ts
var styles = __webpack_require__(45129);
// EXTERNAL MODULE: ./components/YotpoReviews/YotpoWidget.tsx
var YotpoWidget = __webpack_require__(42273);
// EXTERNAL MODULE: ./stores/use-fps-store/index.ts + 2 modules
var use_fps_store = __webpack_require__(2729);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js + 3 modules
var tabs = __webpack_require__(9211);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Divider/index.ts + 2 modules
var Divider = __webpack_require__(38139);
// EXTERNAL MODULE: ./components/IconDynamic/index.ts + 1 modules
var IconDynamic = __webpack_require__(97390);
;// CONCATENATED MODULE: ./fragile/components/PdpConditionSelector/PdpConditionSelector.tsx







var ConditionOption;
(function(ConditionOption) {
    ConditionOption["GUARANTEED_NEW"] = "GUARANTEED_NEW";
    ConditionOption["LIKE_NEW"] = "LIKE_NEW";
})(ConditionOption || (ConditionOption = {}));
var PdpConditionSelector = function(param) {
    var selectedConditionOption = param.selectedConditionOption, setConditionOption = param.setConditionOption, selectedUpgradeOption = param.selectedUpgradeOption;
    var CHOOSE_TITLE = (0,hooks/* useTranslation */.$G)("subscription_pdp_choose_condition");
    var GUARANTEED_TITLE = (0,hooks/* useTranslation */.$G)("subscription_pdp_guaranteed_condition");
    var MINIMUM_TITLE = (0,hooks/* useTranslation */.$G)("subscription_pdp_minimum_condition");
    // Calculate savings dynamically based on the difference between setupFeeUpgradePrice and setupFeePrice
    var calculateSavings = function() {
        var _selectedUpgradeOption_setupFeeUpgrade_options_, _selectedUpgradeOption_setupFeeUpgrade;
        var setupFeeUpgradePrice = (_selectedUpgradeOption_setupFeeUpgrade_options_ = (_selectedUpgradeOption_setupFeeUpgrade = selectedUpgradeOption.setupFeeUpgrade) === null || _selectedUpgradeOption_setupFeeUpgrade === void 0 ? void 0 : _selectedUpgradeOption_setupFeeUpgrade.options[0]) === null || _selectedUpgradeOption_setupFeeUpgrade_options_ === void 0 ? void 0 : _selectedUpgradeOption_setupFeeUpgrade_options_.price;
        if (setupFeeUpgradePrice && typeof setupFeeUpgradePrice.amount === "number") {
            var savingsAmount = setupFeeUpgradePrice.amount;
            if (savingsAmount > 0) {
                return "Save $".concat(Math.floor(savingsAmount / 100));
            }
        }
        return "";
    };
    var conditionTabs = [
        {
            title: "Like-New — ".concat(MINIMUM_TITLE),
            description: "A refurbished PC that meets or exceeds the listed parts and performance.",
            body: [
                "Thoroughly tested and restored to like-new condition",
                "Parts may vary but will always meet or exceed what's shown",
                "FPS is at or above the listed minimums for popular games"
            ],
            price: calculateSavings(),
            iconName: "IconReinforcedExtendedTubing",
            conditionType: ConditionOption.LIKE_NEW
        },
        {
            title: "New — ".concat(GUARANTEED_TITLE),
            description: "A brand-new PC with the exact parts and performance listed.",
            body: [
                "Fresh from the factory and never used",
                "Includes the exact CPU, GPU, RAM, storage, and case shown",
                "FPS matches listed averages for popular games"
            ],
            iconName: "IconGiveaway",
            conditionType: ConditionOption.GUARANTEED_NEW
        }
    ];
    // Get the index of the selected condition option
    var selectedIndex = conditionTabs.findIndex(function(tab) {
        return tab.conditionType === selectedConditionOption;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-lg font-semibold mb-4",
                children: CHOOSE_TITLE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Group */.O.Group, {
                selectedIndex: selectedIndex !== -1 ? selectedIndex : 0,
                onChange: function(index) {
                    setConditionOption(conditionTabs[index].conditionType);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
                    className: "flex flex-col gap-4",
                    children: conditionTabs.map(function(tab) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab */.O, {
                            className: function(param) {
                                var selected = param.selected;
                                return classnames_default()("w-full rounded-lg py-4 px-3 cursor-pointer border focus-visible:outline-none transition text-left", {
                                    "shadow-activeBorder border-transparent": selected,
                                    "border-nzxt-light-grey-300 hover:border-gray-300": !selected
                                });
                            },
                            children: function(param) {
                                var selected = param.selected;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-left w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between items-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDynamic/* default */.Z, {
                                                            iconName: tab.iconName,
                                                            className: "w-5 h-5 text-gray-700"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-semibold text-sm",
                                                            children: tab.title
                                                        })
                                                    ]
                                                }),
                                                tab.price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-sm font-semibold",
                                                    children: tab.price
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-gray-600 text-xs py-2",
                                            children: tab.description
                                        }),
                                        selected && tab.body && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "py-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "list-disc px-4 mt-2 text-sm",
                                                    children: tab.body.map(function(spec) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "text-gray-600 py-0.5",
                                                            children: spec
                                                        }, spec);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        }, tab.title);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var PdpConditionSelector_PdpConditionSelector = (/*#__PURE__*/(0,react.memo)(PdpConditionSelector));

// EXTERNAL MODULE: ./components/PDP/KeySpecs/Cards/FpsCardPrebuild.tsx
var FpsCardPrebuild = __webpack_require__(52196);
;// CONCATENATED MODULE: ./fragile/components/ComponentSummary/ComponentSummary.tsx





var ComponentSummary = function(param) {
    var products = param.products, selectedUpgradeOption = param.selectedUpgradeOption, selectedConditionOption = param.selectedConditionOption, parts = param.parts;
    var _partsData_operatingSystem, _partsData_cpu, _perfItems_find, _partsData_gpu, _perfItems_find1, _partsData_memory, _memItems_find, _partsData_storage, _memItems_find1, _partsData_case;
    var SOCKET_NAME_CPU = (0,hooks/* useTranslation */.$G)("prebuild_socket_cpu");
    var SOCKET_NAME_GPU = (0,hooks/* useTranslation */.$G)("prebuild_socket_gpu");
    var SOCKET_NAME_MEMORY = (0,hooks/* useTranslation */.$G)("prebuild_socket_memory");
    var SOCKET_NAME_STORAGE = (0,hooks/* useTranslation */.$G)("prebuild_socket_storage");
    var PREBUILD_WINDOWS = (0,hooks/* useTranslation */.$G)("prebuild_windows");
    // Function to get parts data from the Fragile API
    var getPartsData = function() {
        if (!selectedUpgradeOption || !parts) {
            return {
                operatingSystem: null,
                cpu: null,
                gpu: null,
                memory: null,
                storage: null,
                case: null
            };
        }
        // Get the parts for the selected upgrade option
        var productParts = (parts === null || parts === void 0 ? void 0 : parts.parts) && parts.parts[selectedUpgradeOption.name];
        if (!productParts) {
            return {
                operatingSystem: null,
                cpu: null,
                gpu: null,
                memory: null,
                storage: null,
                case: null
            };
        }
        // Function to get the newest part based on revisionDate
        var getPart = function(category) {
            if (!productParts[category] || !Array.isArray(productParts[category])) {
                return null;
            }
            // Sort by revisionDate in descending order and take the first one
            return productParts[category].sort(function(a, b) {
                var dateA = new Date(a.revisionDate).getTime();
                var dateB = new Date(b.revisionDate).getTime();
                if (selectedConditionOption === ConditionOption.LIKE_NEW) {
                    return dateA - dateB;
                }
                return dateB - dateA;
            })[0];
        };
        // Get the parts for each category
        return {
            operatingSystem: getPart("SOFTWARE"),
            cpu: getPart("CPU"),
            gpu: getPart("GPU"),
            memory: getPart("MEMORY"),
            storage: getPart("STORAGE"),
            case: getPart("CASES")
        };
    };
    // Extract CMS data mapping
    var keyToLabelMapPerf = {
        cpu: SOCKET_NAME_CPU,
        gpu: SOCKET_NAME_GPU
    };
    var keyToLabelMapMem = {
        memory: SOCKET_NAME_MEMORY,
        storage: SOCKET_NAME_STORAGE
    };
    var perfItems = products ? Object.entries(keyToLabelMapPerf).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        var productKey = key;
        if (products) {
            if (productKey in products && typeof products[productKey] === "object" && products[productKey] && products[productKey].heading) {
                var heading = products[productKey].heading;
                return {
                    key: key,
                    heading: heading
                };
            }
        }
        return null;
    }).filter(Boolean) : [];
    var memItems = products ? Object.entries(keyToLabelMapMem).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        var productKey = key;
        if (products) {
            if (productKey in products && typeof products[productKey] === "object" && products[productKey] && products[productKey].heading) {
                var heading = products[productKey].heading;
                return {
                    key: key,
                    heading: heading
                };
            }
        }
        return null;
    }).filter(Boolean) : [];
    // Get parts data if we're using it
    var partsData = getPartsData();
    var _partsData_operatingSystem_friendlyName, _partsData_cpu_friendlyName, _partsData_gpu_friendlyName, _partsData_memory_friendlyName, _partsData_storage_friendlyName, _partsData_case_friendlyName;
    // If we're in flex mode or using parts data, show the flex-style layout
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold mb-1",
                        children: "Operating System"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: (_partsData_operatingSystem_friendlyName = (_partsData_operatingSystem = partsData.operatingSystem) === null || _partsData_operatingSystem === void 0 ? void 0 : _partsData_operatingSystem.friendlyName) !== null && _partsData_operatingSystem_friendlyName !== void 0 ? _partsData_operatingSystem_friendlyName : PREBUILD_WINDOWS
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold mb-1 ",
                        children: "CPU"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: ((_partsData_cpu_friendlyName = (_partsData_cpu = partsData.cpu) === null || _partsData_cpu === void 0 ? void 0 : _partsData_cpu.friendlyName) !== null && _partsData_cpu_friendlyName !== void 0 ? _partsData_cpu_friendlyName : (_perfItems_find = perfItems.find(function(p) {
                            return p.key === "cpu";
                        })) === null || _perfItems_find === void 0 ? void 0 : _perfItems_find.heading) || "Loading..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold mb-1",
                        children: "GPU"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: ((_partsData_gpu_friendlyName = (_partsData_gpu = partsData.gpu) === null || _partsData_gpu === void 0 ? void 0 : _partsData_gpu.friendlyName) !== null && _partsData_gpu_friendlyName !== void 0 ? _partsData_gpu_friendlyName : (_perfItems_find1 = perfItems.find(function(p) {
                            return p.key === "gpu";
                        })) === null || _perfItems_find1 === void 0 ? void 0 : _perfItems_find1.heading) || "Loading..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold mb-1",
                        children: "Memory"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: ((_partsData_memory_friendlyName = (_partsData_memory = partsData.memory) === null || _partsData_memory === void 0 ? void 0 : _partsData_memory.friendlyName) !== null && _partsData_memory_friendlyName !== void 0 ? _partsData_memory_friendlyName : (_memItems_find = memItems.find(function(p) {
                            return p.key === "memory";
                        })) === null || _memItems_find === void 0 ? void 0 : _memItems_find.heading) || "Loading..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold mb-1",
                        children: "Storage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: ((_partsData_storage_friendlyName = (_partsData_storage = partsData.storage) === null || _partsData_storage === void 0 ? void 0 : _partsData_storage.friendlyName) !== null && _partsData_storage_friendlyName !== void 0 ? _partsData_storage_friendlyName : (_memItems_find1 = memItems.find(function(p) {
                            return p.key === "storage";
                        })) === null || _memItems_find1 === void 0 ? void 0 : _memItems_find1.heading) || "Loading..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-bold mb-1",
                        children: "Case"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: (_partsData_case_friendlyName = (_partsData_case = partsData.case) === null || _partsData_case === void 0 ? void 0 : _partsData_case.friendlyName) !== null && _partsData_case_friendlyName !== void 0 ? _partsData_case_friendlyName : "Loading..."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ComponentSummary_ComponentSummary = (/*#__PURE__*/(0,react.memo)(ComponentSummary));

;// CONCATENATED MODULE: ./fragile/components/ComponentSummary/index.ts

/* harmony default export */ var components_ComponentSummary = (ComponentSummary_ComponentSummary);

;// CONCATENATED MODULE: ./fragile/components/PartsPerformance/PartsPerformanceCard.tsx







var PartsPerformanceCard = function(param) {
    var selectedConditionOption = param.selectedConditionOption, selectedUpgradeOption = param.selectedUpgradeOption, parts = param.parts, noContentWrapper = param.noContentWrapper;
    var isGuaranteedNew = selectedConditionOption === ConditionOption.GUARANTEED_NEW;
    var summaryProds = selectedUpgradeOption.fromCms;
    // Title based on condition
    var title = isGuaranteedNew ? (0,hooks/* useTranslation */.$G)("subscription_pdp_guaranteed_condition") : (0,hooks/* useTranslation */.$G)("subscription_pdp_minimum_condition");
    // Description text for parts section
    var partsDescription = isGuaranteedNew ? (0,hooks/* useTranslation */.$G)("subscription_pdp_guaranteed_description") : (0,hooks/* useTranslation */.$G)("subscription_pdp_minimum_description");
    // Description text for performance section
    var performanceDescription = isGuaranteedNew ? (0,hooks/* useTranslation */.$G)("subscription_pdp_avg_fps") : (0,hooks/* useTranslation */.$G)("subscription_pdp_min_fps");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("w-full rounded-lg overflow-hidden bg-gray-50", {
            "p-6": !noContentWrapper
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-lg font-semibold mt-4 mb-6 text-center",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-2 px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-gray-600 bg-nzxt-light-grey-100 rounded-lg p-4 mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-lg font-semibold",
                                    children: "Parts"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-gray-600 text-sm mt-1 mb-5",
                                    children: partsDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ComponentSummary, {
                                    products: summaryProds,
                                    selectedUpgradeOption: selectedUpgradeOption,
                                    selectedConditionOption: selectedConditionOption,
                                    parts: parts
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-lg p-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-lg",
                                    children: "Performance"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-gray-600 text-sm mt-1 mb-5",
                                    children: performanceDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FpsCardPrebuild/* default */.Z, {
                                    noContentWrapper: true,
                                    noHeading: true,
                                    noBackground: true,
                                    noDisclaimer: true,
                                    noContentWrapperStyle: true,
                                    noTimeSpy: true,
                                    maxGames: 6
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PartsPerformance_PartsPerformanceCard = (/*#__PURE__*/(0,react.memo)(PartsPerformanceCard));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./utils/slugify.ts
var slugify = __webpack_require__(41019);
// EXTERNAL MODULE: ./fragile/components/ColorSelect/extraStyles.module.css
var extraStyles_module = __webpack_require__(9528);
var extraStyles_module_default = /*#__PURE__*/__webpack_require__.n(extraStyles_module);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(46115);
;// CONCATENATED MODULE: ./fragile/components/ColorSelect/styles.ts


var container = (0,tailwindcss_classnames/* classnames */.d)("lg:hidden");
var wrapper = (0,tailwindcss_classnames/* classnames */.d)("py-8", "mb-2");
var helperText = (0,tailwindcss_classnames/* classnames */.d)("text-base", "font-semibold", "mb-3");
var mediaWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative");
var inActiveBackground = (0,tailwindcss_classnames/* classnames */.d)("border", "border-nzxt-light-grey-300", "dark:border-nzxt-dark-grey-100", "border-dashed");
var inActiveBackgroundAvail = (0,tailwindcss_classnames/* classnames */.d)("border-nzxt-light-grey-300", "dark:border-nzxt-dark-grey-100", "border");
var activeBackground = (0,tailwindcss_classnames/* classnames */.d)("border", "border-transparent", "shadow-activeBorder");
var activeButton = function(isActive, isAvailable) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, inActiveBackground, !isActive && isAvailable), (0,_define_property/* default */.Z)(_obj, inActiveBackgroundAvail, !isActive && !isAvailable), (0,_define_property/* default */.Z)(_obj, activeBackground, isActive), _obj), "flex", "items-start", "rounded-md", "flex-row", "w-full", "py-3", "px-2", "gap-2", "min-h-full");
};
var smallborder = (0,tailwindcss_classnames/* classnames */.d)("border-[13px]");
var defaultborder = (0,tailwindcss_classnames/* classnames */.d)("border-[16px]");
var colorSelectButton = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, smallborder, isSmall), (0,_define_property/* default */.Z)(_obj, defaultborder, !isSmall), _obj), "border-nzxt-light-grey-300", "dark:border-nzxt-dark-grey-400", "flex", "flex-col", "items-center", "justify-center", "focus:p-4", "relative");
};
var innerColorSelect = (0,tailwindcss_classnames/* classnames */.d)("absolute");
var sharedColorStyle = (0,tailwindcss_classnames/* classnames */.d)("grid", "grid-cols-2", "gap-4");
var colorItems = (0,tailwindcss_classnames/* classnames */.d)(sharedColorStyle);
var productColor = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "font-semibold", "mt-2");
var productColorIncluded = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "text-gray-600", "mt-2", "ml-auto", "hidden", "md:block");

;// CONCATENATED MODULE: ./fragile/components/ColorSelect/ColorSelectItems.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-nested-ternary */ 








var ColorSelectItems = function(param) {
    var setUpgradeOption = param.setUpgradeOption, selectedUpgradeOption = param.selectedUpgradeOption, upgradeOptions = param.upgradeOptions, productName = param.productName, _param_showIncludedLabel = param.showIncludedLabel, showIncludedLabel = _param_showIncludedLabel === void 0 ? true : _param_showIncludedLabel, slug = param.slug, _param_isSmall = param.isSmall, isSmall = _param_isSmall === void 0 ? false : _param_isSmall;
    var COLOR_LABEL = (0,hooks/* useTranslation */.$G)("subscription_pdp_choose_color");
    var CHOOSE_LABEL = (0,hooks/* useTranslation */.$G)("choose_label");
    var INCLUDED_LABEL = (0,hooks/* useTranslation */.$G)("subscription_pdp_color_included");
    var handleSelect = function(index) {
        setUpgradeOption(upgradeOptions[index]);
    };
    var smallRadiusSize = "24px";
    var defaultRadiusSize = "30px";
    var smallPos = "-12px";
    var defaultPos = "-15px";
    var radius = isSmall ? smallRadiusSize : defaultRadiusSize;
    var position = isSmall ? smallPos : defaultPos;
    var oneColor = {
        borderRadius: "50%",
        left: position
    };
    var composedClassName = (0,react.useMemo)(function() {
        var _obj;
        return (0,clsx_m/* default */.Z)((extraStyles_module_default()).swatch, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (extraStyles_module_default()).swatchDefault, !isSmall), (0,_define_property/* default */.Z)(_obj, (extraStyles_module_default()).swatchSmall, isSmall), _obj));
    }, [
        isSmall
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: helperText,
                children: COLOR_LABEL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: colorItems,
                "data-test-id": "".concat((0,slugify/* default */.Z)(slug), "-color-variant-select"),
                children: upgradeOptions.map(function(upgradeOption, i) {
                    return upgradeOption.fromCms.colorCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: activeButton(upgradeOption === selectedUpgradeOption, upgradeOption.fromCms.isOutOfStock),
                        onClick: function() {
                            return handleSelect(i);
                        },
                        type: "button",
                        "aria-pressed": Boolean(upgradeOption === selectedUpgradeOption),
                        "aria-label": "".concat(CHOOSE_LABEL, " ").concat(productName, " ").concat(upgradeOption.displayName),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: colorSelectButton(isSmall),
                                style: {
                                    borderRadius: "50%",
                                    width: radius,
                                    height: radius
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: composedClassName,
                                    style: {
                                        borderRadius: "50%",
                                        backgroundColor: "rgba(255,255,255, 0)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: innerColorSelect,
                                        style: (0,_object_spread/* default */.Z)({
                                            backgroundColor: "".concat(upgradeOption.fromCms.colorCode.hex),
                                            width: radius,
                                            height: radius,
                                            top: position
                                        }, oneColor)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: productColor,
                                children: upgradeOption.displayName
                            }),
                            !upgradeOption.price && showIncludedLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: productColorIncluded,
                                children: INCLUDED_LABEL
                            })
                        ]
                    }, upgradeOption.name) : null;
                })
            })
        ]
    });
};
/* harmony default export */ var ColorSelect_ColorSelectItems = (/*#__PURE__*/(0,react.memo)(ColorSelectItems));

// EXTERNAL MODULE: ./components/Image/index.tsx + 1 modules
var Image = __webpack_require__(87439);
// EXTERNAL MODULE: ./utils/gtm/index.ts + 3 modules
var gtm = __webpack_require__(20859);
// EXTERNAL MODULE: ./components/PDP/ColorSelect/ImageModal/index.ts + 2 modules
var ImageModal = __webpack_require__(10058);
// EXTERNAL MODULE: ./components/PDP/ProductSlider/index.ts + 2 modules
var ProductSlider = __webpack_require__(92393);
// EXTERNAL MODULE: ./components/PDP/ColorSelect/styles.ts
var ColorSelect_styles = __webpack_require__(91464);
;// CONCATENATED MODULE: ./fragile/components/ColorSelectGallery/ColorSelectGallery.tsx
/* provided dependency */ var process = __webpack_require__(34155);
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/no-array-index-key */ 








var ColorSelectGallery = function(param) {
    var images = param.images, productName = param.productName, _param_showThumbnails = param.showThumbnails, showThumbnails = _param_showThumbnails === void 0 ? true : _param_showThumbnails, _param_gradient = param.gradient, gradient = _param_gradient === void 0 ? null : _param_gradient;
    var isSm = (0,hooks/* useMedia */.GS)("sm");
    var isMd = (0,hooks/* useMedia */.GS)("md");
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), ready = _useState[0], setReady = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), open = _useState1[0], setOpen = _useState1[1];
    var _useState2 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(null), 2), modalIndex = _useState2[0], setModalIndex = _useState2[1];
    var IMAGE_MODAL_LABEL = (0,hooks/* useTranslation */.$G)("image_zoom_modal");
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            return setReady(true);
        }, 1);
        return function() {
            clearTimeout(timer);
        };
    }, [
        images
    ]);
    var maxNumberOfImages = images.length >= 6 ? images.slice(0, 6) : images;
    var handleImageClickLg = function(index) {
        setOpen(true);
        setModalIndex(index);
        gtm/* default.dataLayer */.Z.dataLayer({
            dataLayer: {
                event: "imageInteraction",
                interactionType: "openModal"
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    aspectRatio: "auto"
                },
                children: ready && Array.isArray(maxNumberOfImages) && maxNumberOfImages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSlider/* default */.Z, {
                    images: maxNumberOfImages,
                    desktopSlider: !isSm && !isMd && showThumbnails,
                    modalIndex: modalIndex,
                    productName: productName,
                    openModal: function() {
                        return setOpen(true);
                    },
                    gradient: gradient,
                    isSliderCompact: process.env.NEXT_PUBLIC_FEATURE_FLEX_SLIDER_COMPACT === "true",
                    children: maxNumberOfImages.map(function(image, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (!isSm || !isMd) && gradient ? undefined : ColorSelect_styles/* imageItem */.kT,
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: image.responsiveImage.height / 1.33
                                },
                                children: isSm || isMd ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    className: isSm || isMd ? ColorSelect_styles/* img */.lv : undefined,
                                    data: image.responsiveImage,
                                    width: image.responsiveImage.width,
                                    height: image.responsiveImage.height,
                                    loading: "eager"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    onClick: function() {
                                        return handleImageClickLg(i);
                                    },
                                    tabIndex: -1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        className: isSm || isMd ? ColorSelect_styles/* img */.lv : undefined,
                                        data: image.responsiveImage,
                                        width: image.responsiveImage.width,
                                        height: image.responsiveImage.height,
                                        pictureStyle: {
                                            width: image.responsiveImage.height / 2,
                                            height: image.responsiveImage.height / 2
                                        },
                                        loading: "eager"
                                    })
                                })
                            })
                        }, "".concat(image.id, "-").concat(i));
                    })
                }, images[0].id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageModal/* default */.Z, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                ariaLabel: function() {
                    return IMAGE_MODAL_LABEL;
                },
                children: ready && Array.isArray(maxNumberOfImages) && maxNumberOfImages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: ColorSelect_styles/* modalSliderWrapper */.Ew,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSlider/* default */.Z, {
                        images: maxNumberOfImages,
                        isModalOpen: open,
                        modalIndex: modalIndex,
                        productName: productName,
                        children: maxNumberOfImages.map(function(image, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (!isSm || !isMd) && ColorSelect_styles/* imageItem */.kT,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    data: image.responsiveImage,
                                    width: image.responsiveImage.width,
                                    height: image.responsiveImage.height,
                                    loading: "eager"
                                })
                            }, "".concat(image.id, "-").concat(i));
                        })
                    }, images[0].id)
                })
            })
        ]
    });
};
/* harmony default export */ var ColorSelectGallery_ColorSelectGallery = (/*#__PURE__*/(0,react.memo)(ColorSelectGallery));

// EXTERNAL MODULE: ./components/PDP/AvailabilityMessage/styles.ts
var AvailabilityMessage_styles = __webpack_require__(69094);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./fragile/components/PdpTierSelector/PdpTierSelector.tsx







var LinkToSubscription = function(param) {
    var selected = param.selected, href = param.href, className = param.className, children = param.children;
    return selected === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        className: className,
        scroll: false,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
var PopularBadge = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "font-semibold text-xs px-2 py-1 rounded inline-block bg-nzxt-teal-100 dark:bg-nzxt-teal-300 text-nzxt-teal-500",
        children: "Popular"
    });
};
var PrimeBadge = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "font-medium text-xs px-2 py-1 rounded inline-block bg-nzxt-violet-500 dark:bg-nzxt-violet-300 text-white",
        children: "Prime"
    });
};
var PdpTierSelector = function(param) {
    var selectedPrimaryIndex = param.selectedPrimaryIndex, selectedSecondaryIndex = param.selectedSecondaryIndex, groupedTabs = param.groupedTabs;
    var _groupedTabs_selectedPrimaryIndex_tabs_find, _groupedTabs_selectedPrimaryIndex, _groupedTabs_selectedPrimaryIndex_tabs;
    var CHOOSE_TEXT = (0,hooks/* useTranslation */.$G)("subscription_pdp_choose_tier");
    var selectedPrice = (_groupedTabs_selectedPrimaryIndex_tabs_find = (_groupedTabs_selectedPrimaryIndex = groupedTabs[selectedPrimaryIndex]) === null || _groupedTabs_selectedPrimaryIndex === void 0 ? void 0 : (_groupedTabs_selectedPrimaryIndex_tabs = _groupedTabs_selectedPrimaryIndex.tabs) === null || _groupedTabs_selectedPrimaryIndex_tabs === void 0 ? void 0 : _groupedTabs_selectedPrimaryIndex_tabs.find(function(tab, idx) {
        return idx === selectedSecondaryIndex;
    })) === null || _groupedTabs_selectedPrimaryIndex_tabs_find === void 0 ? void 0 : _groupedTabs_selectedPrimaryIndex_tabs_find.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 text-base font-semibold",
                children: CHOOSE_TEXT
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Group */.O.Group, {
                selectedIndex: selectedPrimaryIndex,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
                    className: "flex gap-4 py-3",
                    children: groupedTabs.map(function(group, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab */.O, {
                            as: LinkToSubscription,
                            selected: idx === selectedPrimaryIndex,
                            href: group.tabs[0].slug,
                            className: function(param) {
                                var selected = param.selected;
                                return classnames_default()("w-full h-full rounded-lg py-2 px-1 cursor-pointer border focus-visible:outline-none hover:shadow-activeBorder hover:border-transparent dark:hover:border-transparent transition", {
                                    "shadow-activeBorder border-transparent": selected,
                                    "border-nzxt-light-grey-300 bg-nzxt-light-grey-50 dark:bg-nzxt-dark-grey-500": !selected
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col text-center items w-full gap-y-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-xs text-center font-semibold text-gray-900",
                                        children: group.title.replace("Player:", "Flex:")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("text-xs", {
                                            "text-gray-800 font-semibold": idx === selectedPrimaryIndex,
                                            "text-gray-700": idx !== selectedPrimaryIndex
                                        }),
                                        children: selectedPrice && idx === selectedPrimaryIndex ? selectedPrice : "$".concat(group.price, "/mo")
                                    })
                                ]
                            })
                        }, group.title);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Group */.O.Group, {
                selectedIndex: selectedSecondaryIndex,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
                    className: "flex flex-col gap-4",
                    children: groupedTabs[selectedPrimaryIndex].tabs.map(function(tab, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab */.O, {
                            as: LinkToSubscription,
                            selected: idx === selectedSecondaryIndex,
                            href: tab.slug,
                            className: function(param) {
                                var selected = param.selected;
                                return classnames_default()("w-full h-full rounded-lg py-4 px-3 cursor-pointer border focus-visible:outline-none hover:shadow-activeBorder hover:border-transparent dark:hover:border-transparent transition", {
                                    "shadow-activeBorder border-transparent": selected,
                                    "border-nzxt-light-grey-300 dark:border-nzxt-dark-grey-100": !selected
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex text-left items-center w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-gray-600 text-sm float-right",
                                            children: tab.price
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "font-semibold text-sm flex gap-2 items-center",
                                            children: [
                                                tab.title,
                                                " ",
                                                tab.slug.includes("-prime") && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimeBadge, {}),
                                                " ",
                                                tab.popular && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularBadge, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-gray-600 text-xs py-1",
                                            children: tab.description
                                        }),
                                        idx === selectedSecondaryIndex && tab.specs && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "py-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "list-disc pl-5 mt-2 text-sm px-4",
                                                    children: tab.specs.map(function(spec) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "text-gray-600 py-0.5",
                                                            children: spec
                                                        }, spec);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, tab.slug);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var PdpTierSelector_PdpTierSelector = (/*#__PURE__*/(0,react.memo)(PdpTierSelector));

// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(87029);
// EXTERNAL MODULE: ./components/PDP/BuyButtonGroup/styles.ts
var BuyButtonGroup_styles = __webpack_require__(70494);
// EXTERNAL MODULE: ./components/Button/index.ts + 3 modules
var Button = __webpack_require__(49072);
;// CONCATENATED MODULE: ./fragile/components/BuySummary/BuySummary.tsx
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];










var BuySummary = function(param) {
    var subscriptionProductName = param.subscriptionProductName, shortDescription = param.shortDescription, selectedUpgradeOption = param.selectedUpgradeOption, subscriptionProduct = param.subscriptionProduct, isRegionallyAvailable = param.isRegionallyAvailable, isVisible = param.isVisible, selectedConditionOption = param.selectedConditionOption, isOutOfStockConditionMap = param.isOutOfStockConditionMap;
    var _subscriptionProduct_products__upgrades__options, _subscriptionProduct_products__upgrades, _subscriptionProduct_products, _subscriptionProduct_products__upgrades__options_, _subscriptionProduct_products__upgrades__options__fromCms;
    var displayMarketingBanner = (0,use_ui_store/* default */.ZP)(use_ui_store/* getDisplayMarketingBanner */.Md);
    var displayCart = (0,use_ui_store/* default */.ZP)(use_ui_store/* getDisplayCart */.wt);
    var SUBSCRIBE_CTA = (0,hooks/* useTranslation */.$G)("subscribe_cta");
    var OUT_OF_STOCK = (0,hooks/* useTranslation */.$G)("message_out_of_stock");
    var fragileSubscribeUrl = selectedUpgradeOption ? selectedUpgradeOption.fromCms.fragileCheckoutUrl : (_subscriptionProduct_products__upgrades__options = (_subscriptionProduct_products__upgrades = (_subscriptionProduct_products = subscriptionProduct.products) === null || _subscriptionProduct_products === void 0 ? void 0 : _subscriptionProduct_products[0].upgrades) === null || _subscriptionProduct_products__upgrades === void 0 ? void 0 : _subscriptionProduct_products__upgrades[0].options) === null || _subscriptionProduct_products__upgrades__options === void 0 ? void 0 : (_subscriptionProduct_products__upgrades__options_ = _subscriptionProduct_products__upgrades__options[0]) === null || _subscriptionProduct_products__upgrades__options_ === void 0 ? void 0 : (_subscriptionProduct_products__upgrades__options__fromCms = _subscriptionProduct_products__upgrades__options_.fromCms) === null || _subscriptionProduct_products__upgrades__options__fromCms === void 0 ? void 0 : _subscriptionProduct_products__upgrades__options__fromCms.fragileCheckoutUrl;
    var getUrl = function() {
        try {
            var initialUrl = sessionStorage.getItem("initialUrl");
            if (!initialUrl) {
                return fragileSubscribeUrl;
            }
            var userURL = new URL(initialUrl);
            var url = new URL(fragileSubscribeUrl);
            userURL.searchParams.forEach(function(value, key) {
                url.searchParams.set(key, value);
            });
            // Add condition option upgrades to the URL
            if (selectedConditionOption === ConditionOption.GUARANTEED_NEW) {
                var _selectedUpgradeOption_setupFeeProduct, _selectedUpgradeOption_setupFeeUpgrade, _selectedUpgradeOption_setupFeeUpgrade1, _selectedUpgradeOption_setupFeeUpgrade_options;
                var upgrades = [
                    {
                        productId: (_selectedUpgradeOption_setupFeeProduct = selectedUpgradeOption.setupFeeProduct) === null || _selectedUpgradeOption_setupFeeProduct === void 0 ? void 0 : _selectedUpgradeOption_setupFeeProduct.id,
                        upgradeId: (_selectedUpgradeOption_setupFeeUpgrade = selectedUpgradeOption.setupFeeUpgrade) === null || _selectedUpgradeOption_setupFeeUpgrade === void 0 ? void 0 : _selectedUpgradeOption_setupFeeUpgrade.id,
                        optionId: (_selectedUpgradeOption_setupFeeUpgrade1 = selectedUpgradeOption.setupFeeUpgrade) === null || _selectedUpgradeOption_setupFeeUpgrade1 === void 0 ? void 0 : (_selectedUpgradeOption_setupFeeUpgrade_options = _selectedUpgradeOption_setupFeeUpgrade1.options) === null || _selectedUpgradeOption_setupFeeUpgrade_options === void 0 ? void 0 : _selectedUpgradeOption_setupFeeUpgrade_options[0].id
                    }
                ];
                // Base64 encode the upgrades array
                var upgradesBase64 = Buffer.from(JSON.stringify(upgrades)).toString("base64");
                url.searchParams.set("upgrades", upgradesBase64);
            }
            // Do nothing for LIKE_NEW condition option
            return url.toString();
        } catch (e) {
            return fragileSubscribeUrl;
        }
    };
    var isDisabled = !fragileSubscribeUrl || isOutOfStockConditionMap[selectedConditionOption];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("bld-summary fixed flex left-0 right-0 bg-nzxt-light-grey-100 min-h-[100px] items-center dark:bg-purpleshame z-[49] transition-all lg:transition-none ease-in-out duration-200", {
            "top-0 lg:top-auto lg:bottom-0 md:flex lg:flex border-nzxt-light-grey-200 transform translate-y-0 opacity-100 lg:translate-y-0 lg:opacity-100": isVisible && displayMarketingBanner && !displayCart,
            "top-[101px] md:top-[109px] lg:top-auto lg:bottom-0 md:flex lg:flex border-nzxt-light-grey-200 transform translate-y-0 opacity-100 lg:translate-y-0 lg:opacity-100": isVisible && !displayMarketingBanner && !displayCart,
            "top-0 lg:top-auto lg:bottom-0 lg:flex transform translate-y-[-30px] md:translate-y-[-10px] lg:translate-y-0 opacity-0 lg:opacity-100": !isVisible && displayMarketingBanner && !displayCart,
            "md:top-[109px] lg:top-auto lg:bottom-0 lg:flex transform translate-y-[-30px] md:translate-y-[-10px] lg:translate-y-0 opacity-0 lg:opacity-100": !isVisible && !displayMarketingBanner && !displayCart,
            hidden: displayCart
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center lg:px-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:w-1/2 md:flex md:items-start items-center hidden flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-bold",
                                "data-test-id": "product-name-heading",
                                children: subscriptionProductName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xs",
                                "data-test-id": "product-shrt-des",
                                children: shortDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:w-1/2 flex justify-end items-center w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1/2 flex flex-col md:items-end",
                                children: isRegionallyAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-base font-semibold space-x-2",
                                            "data-test-id": "product-price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                suppressHydrationWarning: true,
                                                "data-test-id": "product-price-amount",
                                                children: "$".concat(Math.floor(subscriptionProduct.monthlyPrice / 100), "/mo")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs ".concat(styles/* greyText */.dE),
                                            children: (0,hooks/* useTranslation */.$G)("subscription_pdp_nzxt_flex_support")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-1/2 flex-col px-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    buttonStyle: "primary",
                                    dataTestId: "add-to-cart-button",
                                    type: "button",
                                    disabled: isDisabled,
                                    onClick: function() {
                                        window.location.href = getUrl();
                                    },
                                    customMargin: true,
                                    className: BuyButtonGroup_styles/* cartButton */.Km,
                                    children: isDisabled ? OUT_OF_STOCK : SUBSCRIBE_CTA
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var BuySummary_BuySummary = (/*#__PURE__*/(0,react.memo)(BuySummary));

;// CONCATENATED MODULE: ./fragile/components/BuySummary/index.ts


;// CONCATENATED MODULE: ./fragile/components/SubscriptionPdp.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 


















var SubscriptionPdp = function(param) {
    var subscriptionProductName = param.subscriptionProductName, shortDescription = param.shortDescription, images = param.images, price = param.price, subscriptionProduct = param.subscriptionProduct, selectedUpgradeOption = param.selectedUpgradeOption, allSubscriptionProducts = param.allSubscriptionProducts, setUpgradeOption = param.setUpgradeOption, selectedConditionOption = param.selectedConditionOption, setConditionOption = param.setConditionOption, isOutOfStockConditionMap = param.isOutOfStockConditionMap;
    var _subscriptionProduct_fromCms, _subscriptionProduct_fromCms1, _subscriptionProduct_fromCms_prebuildLink;
    var isRegionallyAvailable = true;
    var setFps = (0,use_fps_store/* default */.ZP)(use_fps_store/* getSetFps */.eF);
    var clearFps = (0,use_fps_store/* default */.ZP)(use_fps_store/* getClearFps */.Dz);
    // Effect to update FPS data based on the selected upgrade option and condition
    (0,react.useEffect)(function() {
        router_default().events.on("routeChangeComplete", function() {
            return clearFps();
        });
        var timeout = null;
        timeout = setTimeout(function() {
            var _selectedUpgradeOption_fromCms;
            // Use FPS data from the currently selected upgrade option
            if (selectedUpgradeOption === null || selectedUpgradeOption === void 0 ? void 0 : (_selectedUpgradeOption_fromCms = selectedUpgradeOption.fromCms) === null || _selectedUpgradeOption_fromCms === void 0 ? void 0 : _selectedUpgradeOption_fromCms.fps) {
                setFps(selectedUpgradeOption.fromCms.fps);
            } else {
                clearFps();
            }
        }, 2);
        return function() {
            router_default().events.off("routeChangeComplete", function() {
                return clearFps();
            });
            clearTimeout(timeout);
        };
    }, [
        clearFps,
        selectedUpgradeOption,
        selectedConditionOption,
        setFps
    ]);
    var oosChipClass = (0,clsx_m/* default */.Z)(AvailabilityMessage_styles/* base */.ue, AvailabilityMessage_styles/* outOfStock */.Hq);
    var newChipClass = (0,clsx_m/* default */.Z)(AvailabilityMessage_styles/* base */.ue, AvailabilityMessage_styles/* newItem */.CC);
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var scrollY = (0,dist_module/* default */.Z)();
    (0,react.useEffect)(function() {
        setIsVisible(scrollY > 500);
    }, [
        scrollY
    ]);
    // Group the collections and filter out duplicates
    var groupedTabs = (0,react.useMemo)(function() {
        var _product_ConditionOption_LIKE_NEW_fromCms_collection__name;
        // Extract collections and filter out duplicates
        var groupedCollections = allSubscriptionProducts.map(function(product) {
            var _product_ConditionOption_LIKE_NEW_fromCms_collection;
            return (_product_ConditionOption_LIKE_NEW_fromCms_collection__name = (_product_ConditionOption_LIKE_NEW_fromCms_collection = product[ConditionOption.LIKE_NEW].fromCms.collection) === null || _product_ConditionOption_LIKE_NEW_fromCms_collection === void 0 ? void 0 : _product_ConditionOption_LIKE_NEW_fromCms_collection[0].name) !== null && _product_ConditionOption_LIKE_NEW_fromCms_collection__name !== void 0 ? _product_ConditionOption_LIKE_NEW_fromCms_collection__name : "Other";
        }).filter(function(value, index, self) {
            return self.indexOf(value) === index;
        });
        var _product_ConditionOption_LIKE_NEW_fromCms_shortProductName;
        return groupedCollections.map(function(collection) {
            return {
                title: collection,
                // Get lowest price product
                price: Math.floor(allSubscriptionProducts.filter(function(product) {
                    var _product_ConditionOption_LIKE_NEW_fromCms_collection;
                    return ((_product_ConditionOption_LIKE_NEW_fromCms_collection = product[ConditionOption.LIKE_NEW].fromCms.collection) === null || _product_ConditionOption_LIKE_NEW_fromCms_collection === void 0 ? void 0 : _product_ConditionOption_LIKE_NEW_fromCms_collection[0].name) === collection;
                }).sort(function(a, b) {
                    return a[ConditionOption.LIKE_NEW].monthlyPrice > b[ConditionOption.LIKE_NEW].monthlyPrice ? 1 : -1;
                })[0][ConditionOption.LIKE_NEW].monthlyPrice / 100),
                tabs: allSubscriptionProducts.filter(function(product) {
                    var _product_ConditionOption_LIKE_NEW_fromCms_collection;
                    return ((_product_ConditionOption_LIKE_NEW_fromCms_collection = product[ConditionOption.LIKE_NEW].fromCms.collection) === null || _product_ConditionOption_LIKE_NEW_fromCms_collection === void 0 ? void 0 : _product_ConditionOption_LIKE_NEW_fromCms_collection[0].name) === collection;
                }).sort(function(a, b) {
                    return a[ConditionOption.LIKE_NEW].monthlyPrice > b[ConditionOption.LIKE_NEW].monthlyPrice ? 1 : -1;
                }).map(function(product) {
                    var _product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody_split, _product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody;
                    return {
                        title: (_product_ConditionOption_LIKE_NEW_fromCms_shortProductName = product[ConditionOption.LIKE_NEW].fromCms.shortProductName) !== null && _product_ConditionOption_LIKE_NEW_fromCms_shortProductName !== void 0 ? _product_ConditionOption_LIKE_NEW_fromCms_shortProductName : product[ConditionOption.LIKE_NEW].fromCms.name,
                        description: product[ConditionOption.LIKE_NEW].fromCms.customerProfileDescription,
                        slug: product[ConditionOption.LIKE_NEW].fromCms.slug,
                        price: "$".concat(Math.floor(product[ConditionOption.LIKE_NEW].monthlyPrice / 100), "/mo"),
                        popular: product[ConditionOption.LIKE_NEW].fromCms.isPopular,
                        specs: (_product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody_split = (_product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody = product[ConditionOption.LIKE_NEW].fromCms.whyChooseBody) === null || _product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody === void 0 ? void 0 : _product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody.split("\n")) === null || _product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody_split === void 0 ? void 0 : _product_ConditionOption_LIKE_NEW_fromCms_whyChooseBody_split.map(function(item) {
                            return item.trim();
                        })
                    };
                })
            };
        }).sort(function(a, b) {
            return a.price > b.price ? 1 : -1;
        });
    }, [
        allSubscriptionProducts
    ]);
    var selectedPrimaryIndex = (0,react.useMemo)(function() {
        return groupedTabs.findIndex(function(tab) {
            var _subscriptionProduct_fromCms_collection;
            return tab.title === ((_subscriptionProduct_fromCms_collection = subscriptionProduct.fromCms.collection) === null || _subscriptionProduct_fromCms_collection === void 0 ? void 0 : _subscriptionProduct_fromCms_collection[0].name);
        });
    }, [
        groupedTabs,
        subscriptionProduct.fromCms.collection
    ]);
    var selectedSecondaryIndex = (0,react.useMemo)(function() {
        var _groupedTabs_selectedPrimaryIndex;
        return (_groupedTabs_selectedPrimaryIndex = groupedTabs[selectedPrimaryIndex]) === null || _groupedTabs_selectedPrimaryIndex === void 0 ? void 0 : _groupedTabs_selectedPrimaryIndex.tabs.findIndex(function(tab) {
            return tab.slug === subscriptionProduct.fromCms.slug;
        });
    }, [
        groupedTabs,
        selectedPrimaryIndex,
        subscriptionProduct.fromCms.slug
    ]);
    var parts = (0,react.useMemo)(function() {
        return allSubscriptionProducts.find(function(product) {
            var _product_selectedConditionOption, _product_selectedConditionOption_fromCms;
            return ((_product_selectedConditionOption = product[selectedConditionOption]) === null || _product_selectedConditionOption === void 0 ? void 0 : (_product_selectedConditionOption_fromCms = _product_selectedConditionOption.fromCms) === null || _product_selectedConditionOption_fromCms === void 0 ? void 0 : _product_selectedConditionOption_fromCms.slug) === subscriptionProduct.fromCms.slug;
        })[selectedConditionOption].parts;
    }, [
        allSubscriptionProducts,
        selectedConditionOption,
        subscriptionProduct
    ]);
    var _opt_images;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styles/* detailsGrid */.tO,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    (images !== null && images !== void 0 ? images : []).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "preload",
                            as: "image",
                            href: item.url
                        }, item.id);
                    }),
                    subscriptionProduct.fromCms.subscriptionUpgrades.map(function(cmsUpgrade) {
                        return cmsUpgrade.upgradeOptions.map(function(opt) {
                            return (_opt_images = opt.images) !== null && _opt_images !== void 0 ? _opt_images : [];
                        });
                    }).flat(2).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "preload",
                            as: "image",
                            href: item.url
                        }, item.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styles/* column */.$Q,
                "data-test-id": "product-column",
                children: [
                    isOutOfStockConditionMap[selectedConditionOption] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: oosChipClass,
                        "data-test-id": "product-availability-message",
                        suppressHydrationWarning: true,
                        children: (0,hooks/* useTranslation */.$G)("message_out_of_stock")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: newChipClass,
                        "data-test-id": "product-availability-message",
                        suppressHydrationWarning: true,
                        children: (0,hooks/* useTranslation */.$G)("message_new_item")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: styles/* mainDetail */.f2,
                        "data-test-id": "main-detail-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: styles/* fullSpanWrapper */.VT,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: styles/* titleBase */.EQ,
                                        "data-test-id": "product-name-heading",
                                        children: subscriptionProductName
                                    }),
                                    (subscriptionProduct === null || subscriptionProduct === void 0 ? void 0 : (_subscriptionProduct_fromCms = subscriptionProduct.fromCms) === null || _subscriptionProduct_fromCms === void 0 ? void 0 : _subscriptionProduct_fromCms.yotpoProductId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(YotpoWidget/* default */.Z, {
                                        type: "star-rating",
                                        id: subscriptionProduct === null || subscriptionProduct === void 0 ? void 0 : (_subscriptionProduct_fromCms1 = subscriptionProduct.fromCms) === null || _subscriptionProduct_fromCms1 === void 0 ? void 0 : _subscriptionProduct_fromCms1.yotpoProductId,
                                        template: "product"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,clsx_m/* default */.Z)(styles/* greyText */.dE, styles/* fullSpanWrapper */.VT),
                                "data-test-id": "product-shrt-des",
                                children: shortDescription
                            }),
                            isRegionallyAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: styles/* titlePrice */.g8,
                                    "data-test-id": "product-price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        suppressHydrationWarning: true,
                                        className: styles/* isOnSale */.oF(false),
                                        "data-test-id": "product-price-amount",
                                        children: price
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseOptionsNav/* default */.Z, {
                        slug: subscriptionProduct.fromCms.slug,
                        siblingSlug: (_subscriptionProduct_fromCms_prebuildLink = subscriptionProduct.fromCms.prebuildLink) === null || _subscriptionProduct_fromCms_prebuildLink === void 0 ? void 0 : _subscriptionProduct_fromCms_prebuildLink.slug,
                        regionalServices: subscriptionProduct.fromCms.regionalServices
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpTierSelector_PdpTierSelector, {
                        groupedTabs: groupedTabs,
                        selectedPrimaryIndex: selectedPrimaryIndex,
                        selectedSecondaryIndex: selectedSecondaryIndex
                    }),
                    subscriptionProduct.products[0].upgrades.map(function(productUpgrade) {
                        return productUpgrade.fromCms.isColorUpgrade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSelect_ColorSelectItems, {
                            selectedUpgradeOption: selectedUpgradeOption,
                            setUpgradeOption: setUpgradeOption,
                            upgradeOptions: productUpgrade.options.sort(function(a, b) {
                                return a.displayOrder - b.displayOrder;
                            })
                        }, productUpgrade.id) : null;
                    }).filter(function(item) {
                        return item !== null;
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpConditionSelector_PdpConditionSelector, {
                        selectedConditionOption: selectedConditionOption,
                        setConditionOption: setConditionOption,
                        selectedUpgradeOption: selectedUpgradeOption
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden py-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsPerformance_PartsPerformanceCard, {
                            selectedConditionOption: selectedConditionOption,
                            selectedUpgradeOption: selectedUpgradeOption,
                            parts: parts,
                            noContentWrapper: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " relative flex md:flex-col px-0 pb-0 box-border col-span-1 order-1 lg:col-span-7 h-full row-span-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSelectGallery_ColorSelectGallery, {
                        images: images,
                        productName: subscriptionProductName,
                        gradient: subscriptionProduct.fromCms.gradient,
                        showThumbnails: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "gap-2 sticky top-[9.94rem] flex-col sm:flex-row hidden lg:flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsPerformance_PartsPerformanceCard, {
                            selectedConditionOption: selectedConditionOption,
                            selectedUpgradeOption: selectedUpgradeOption,
                            parts: parts,
                            noContentWrapper: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuySummary_BuySummary, {
                subscriptionProductName: subscriptionProductName,
                shortDescription: shortDescription,
                selectedUpgradeOption: selectedUpgradeOption,
                subscriptionProduct: subscriptionProduct,
                isRegionallyAvailable: isRegionallyAvailable,
                isVisible: isVisible,
                selectedConditionOption: selectedConditionOption,
                isOutOfStockConditionMap: isOutOfStockConditionMap
            })
        ]
    });
};
/* harmony default export */ var components_SubscriptionPdp = (/*#__PURE__*/(0,react.memo)(SubscriptionPdp));

// EXTERNAL MODULE: ./components/CollectionPage/ComparisonTable/Table/SingleItemTableSpecs.tsx
var SingleItemTableSpecs = __webpack_require__(49004);
// EXTERNAL MODULE: ./components/PDP/Overview/Overview.tsx
var Overview = __webpack_require__(60451);
// EXTERNAL MODULE: ./components/CollectionPage/ComparisonTable/Table/styles.ts
var Table_styles = __webpack_require__(14470);
// EXTERNAL MODULE: ./utils/sessionStorage.ts
var utils_sessionStorage = __webpack_require__(94791);
// EXTERNAL MODULE: ./components/PDP/ServiceBadge/index.ts + 3 modules
var ServiceBadge = __webpack_require__(17876);
;// CONCATENATED MODULE: ./pages/flex/[slug].tsx























var SubscriptionProductPage = function(param) {
    var baseUrl = param.baseUrl, slug = param.slug, dataWithConditions = param.dataWithConditions, config = param.config;
    var _currentProductData_ConditionOption_LIKE_NEW_products__upgrades_, _currentProductData_ConditionOption_LIKE_NEW_products_, _currentProduct_fromCms_collection, _selectedUpgradeOption_fromCms, _currentProduct_fromCms, _currentProduct_fromCms_overviewContent, _currentProduct_fromCms1, _currentProduct_fromCms2, _currentProduct_fromCms3;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var headerRef = (0,react.useRef)(null);
    var overviewRef = (0,react.useRef)(null);
    var SUBSCRIPTION_AGREEMENT = (0,hooks/* useTranslation */.$G)("subscription_agreement");
    // Find the current product data by matching the slug
    var currentProductData = dataWithConditions.find(function(product) {
        return product[ConditionOption.LIKE_NEW].fromCms.slug === slug;
    });
    // Get the initial product version (standard by default)
    var initialUpgradeOption = ((_currentProductData_ConditionOption_LIKE_NEW_products__upgrades_ = (_currentProductData_ConditionOption_LIKE_NEW_products_ = currentProductData === null || currentProductData === void 0 ? void 0 : currentProductData[ConditionOption.LIKE_NEW].products[0]) === null || _currentProductData_ConditionOption_LIKE_NEW_products_ === void 0 ? void 0 : _currentProductData_ConditionOption_LIKE_NEW_products_.upgrades[0]) === null || _currentProductData_ConditionOption_LIKE_NEW_products__upgrades_ === void 0 ? void 0 : _currentProductData_ConditionOption_LIKE_NEW_products__upgrades_.options[0]) ? currentProductData[ConditionOption.LIKE_NEW].products[0].upgrades[0].options.sort(function(a, b) {
        return a.displayOrder - b.displayOrder;
    })[0] : null;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(initialUpgradeOption), 2), selectedUpgradeOption = _useState[0], setUpgradeOption = _useState[1];
    var fragileConfig = config.perProductConfig[selectedUpgradeOption.name];
    var isOutOfStockConditionMap = (0,react.useMemo)(function() {
        var _selectedUpgradeOption_fromCms;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, ConditionOption.LIKE_NEW, fragileConfig === null || fragileConfig === void 0 ? void 0 : fragileConfig.isOutOfRefurbishedStock), (0,_define_property/* default */.Z)(_obj, ConditionOption.GUARANTEED_NEW, (fragileConfig === null || fragileConfig === void 0 ? void 0 : fragileConfig.isOutOfNewStock) || !!(selectedUpgradeOption === null || selectedUpgradeOption === void 0 ? void 0 : (_selectedUpgradeOption_fromCms = selectedUpgradeOption.fromCms) === null || _selectedUpgradeOption_fromCms === void 0 ? void 0 : _selectedUpgradeOption_fromCms.isOutOfStock)), _obj;
    }, [
        fragileConfig,
        selectedUpgradeOption
    ]);
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(isOutOfStockConditionMap[ConditionOption.LIKE_NEW] ? ConditionOption.GUARANTEED_NEW : ConditionOption.LIKE_NEW), 2), selectedConditionOption = _useState1[0], setConditionOption = _useState1[1];
    // Use useEffect to set the condition option after initial render (client-side only)
    (0,react.useEffect)(function() {
        // This effect only runs once on mount
        var checkPrevPath = function() {
            var isGuaranteedNewOOS = isOutOfStockConditionMap[ConditionOption.GUARANTEED_NEW];
            if (isGuaranteedNewOOS) {
                return;
            }
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get("new-selected") !== null) {
                setConditionOption(ConditionOption.GUARANTEED_NEW);
                return;
            }
            var prevPath = (0,utils_sessionStorage/* getSessionStorage */.G)("prevPath");
            var isComingFromProductPage = prevPath && prevPath.match(/\/product\/player-[\w-]+/);
            if (isComingFromProductPage) {
                setConditionOption(ConditionOption.GUARANTEED_NEW);
            }
        };
        // Check the previous path immediately
        checkPrevPath();
        // Use requestAnimationFrame to ensure the code runs after browser paint
        var animationId = window.requestAnimationFrame(function() {
            checkPrevPath();
        });
        return function() {
            window.cancelAnimationFrame(animationId);
        };
    // Empty dependency array ensures this effect only runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Simple effect to handle both initialization and condition changes
    (0,react.useEffect)(function() {
        if (!currentProductData) return;
        // Get the current condition's product data
        var newProduct = currentProductData[selectedConditionOption];
        var currentName = selectedUpgradeOption.name;
        // Search through products and upgrades to find a matching option
        var matchingOption = null;
        // Use array methods with proper type safety
        newProduct.products.some(function(product) {
            return product.upgrades.some(function(upgrade) {
                var match = upgrade.options.find(function(option) {
                    return option.name === currentName;
                });
                if (match) {
                    matchingOption = match;
                    return true;
                }
                return false;
            });
        });
        if (matchingOption) {
            setUpgradeOption(matchingOption);
        } else {
            setUpgradeOption(initialUpgradeOption);
        }
    }, [
        currentProductData,
        selectedUpgradeOption,
        initialUpgradeOption,
        selectedConditionOption
    ]);
    if (!currentProductData || !currentProductData[ConditionOption.LIKE_NEW].fromCms.slug) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((error_default()), {
            statusCode: 404
        });
    }
    // Get the current product based on the selected condition
    var currentProduct = currentProductData[selectedConditionOption];
    if (!currentProduct) {
        return null;
    }
    var _selectedUpgradeOption_fromCms_images, _currentProduct_fromCms_subscriptionDetails, _currentProduct_fromCms_downloads;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                baseUrl: baseUrl,
                canonical: "".concat(baseUrl, "/").concat(constants/* ROUTE_SUBSCRIPTION */.xzr, "/").concat(query.slug),
                cmsData: currentProduct.fromCms.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "overview_anchor",
                className: "relative",
                children: [
                    Array.isArray(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.fromCms.collection) && ((_currentProduct_fromCms_collection = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.fromCms.collection) === null || _currentProduct_fromCms_collection === void 0 ? void 0 : _currentProduct_fromCms_collection.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductNav/* OuterWrapper */.m, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: headerRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductNav/* ProductNav */.z, {
                                collectionData: currentProduct.fromCms.collection,
                                productName: currentProduct.fromCms.name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: overviewRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SubscriptionPdp, {
                                selectedUpgradeOption: selectedUpgradeOption,
                                setUpgradeOption: setUpgradeOption,
                                selectedConditionOption: selectedConditionOption,
                                setConditionOption: setConditionOption,
                                subscriptionProductName: currentProduct.fromCms.name,
                                shortDescription: currentProduct.fromCms.shortDescription,
                                images: (_selectedUpgradeOption_fromCms_images = selectedUpgradeOption === null || selectedUpgradeOption === void 0 ? void 0 : (_selectedUpgradeOption_fromCms = selectedUpgradeOption.fromCms) === null || _selectedUpgradeOption_fromCms === void 0 ? void 0 : _selectedUpgradeOption_fromCms.images) !== null && _selectedUpgradeOption_fromCms_images !== void 0 ? _selectedUpgradeOption_fromCms_images : currentProduct.fromCms.images,
                                price: "$".concat(Math.floor(currentProduct.monthlyPrice / 100), " per month"),
                                subscriptionProduct: currentProduct,
                                allSubscriptionProducts: dataWithConditions,
                                isOutOfStockConditionMap: isOutOfStockConditionMap
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-12 lg:space-y-20 mb-20 mt-8",
                        children: [
                            (currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct_fromCms = currentProduct.fromCms) === null || _currentProduct_fromCms === void 0 ? void 0 : (_currentProduct_fromCms_overviewContent = _currentProduct_fromCms.overviewContent) === null || _currentProduct_fromCms_overviewContent === void 0 ? void 0 : _currentProduct_fromCms_overviewContent.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview/* default */.Z, {
                                overviewContent: currentProduct.fromCms.overviewContent
                            }),
                            Array.isArray(currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct_fromCms1 = currentProduct.fromCms) === null || _currentProduct_fromCms1 === void 0 ? void 0 : _currentProduct_fromCms1.productFaqs) && (currentProduct === null || currentProduct === void 0 ? void 0 : (_currentProduct_fromCms2 = currentProduct.fromCms) === null || _currentProduct_fromCms2 === void 0 ? void 0 : _currentProduct_fromCms2.productFaqs.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* default */.Z, {
                                noWrapperSpacing: true,
                                titleSize: "small",
                                title: (0,hooks/* useTranslation */.$G)("subscription_faq"),
                                titleAlignment: "Left",
                                faqQuestions: (_currentProduct_fromCms3 = currentProduct.fromCms) === null || _currentProduct_fromCms3 === void 0 ? void 0 : _currentProduct_fromCms3.productFaqs
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
                                noSpacing: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "h5 mb-6 md:mb-9 lg:mb-12",
                                            children: (0,hooks/* useTranslation */.$G)("subscription_details")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleItemTableSpecs/* default */.Z, {
                                            decoratedSpecs: Object.keys((_currentProduct_fromCms_subscriptionDetails = currentProduct.fromCms.subscriptionDetails) !== null && _currentProduct_fromCms_subscriptionDetails !== void 0 ? _currentProduct_fromCms_subscriptionDetails : {}).map(function(detailName) {
                                                return {
                                                    label: detailName,
                                                    value: currentProduct.fromCms.subscriptionDetails[detailName]
                                                };
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: Table_styles/* specsWrapper */.wp,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: Table_styles/* specCategory */.XL,
                                                    children: (0,hooks/* useTranslation */.$G)("subscription_pdp_more_details")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat(Table_styles/* specValueDetail */.rB, " mt-1.5"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceBadge/* default */.Z, {
                                                        data: {
                                                            copy: SUBSCRIPTION_AGREEMENT,
                                                            externalLink: {
                                                                url: "https://fragile.co/legal/subscription-agreement"
                                                            },
                                                            iconName: "IconUrl"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
                                noSpacing: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "h5 mb-6 md:mb-9 lg:mb-12 scroll-mt-[12rem]",
                                            id: "reviews",
                                            children: (0,hooks/* useTranslation */.$G)("reviews_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YotpoWidget/* default */.Z, {
                                            type: "reviews",
                                            productName: currentProduct.fromCms.name,
                                            id: currentProduct.fromCms.yotpoProductId,
                                            slug: currentProduct.fromCms.slug,
                                            description: currentProduct.fromCms.shortDescription
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Downloads/* default */.Z, {
                                downloadsData: (_currentProduct_fromCms_downloads = currentProduct.fromCms.downloads) !== null && _currentProduct_fromCms_downloads !== void 0 ? _currentProduct_fromCms_downloads : []
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SubscriptionProductPage.Layout = Layout/* default */.Z;
var __N_SSG = true;
/* harmony default export */ var _slug_ = (SubscriptionProductPage);


/***/ }),

/***/ 80326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"Modal_dialogOverlay__pqMSX","dialogContent":"Modal_dialogContent__RnOVE"};

/***/ }),

/***/ 9528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swatch":"extraStyles_swatch__chi0u","swatchDefault":"extraStyles_swatchDefault__lF9yr","swatchSmall":"extraStyles_swatchSmall__jmlyN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6427,3584,8448,6119,7589,8985,7381,2393,2368,9774,2888,179], function() { return __webpack_exec__(65403); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);